import React, { useState, useCallback, useEffect, useMemo, useRef } from 'react';

import { createUseStyles } from 'react-jss';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Text from '../components/Text';
import DefaultLayout from '../layouts/DefaultLayout';
import { Helmet } from 'react-helmet';
import Container from 'react-bootstrap/Container';
import ClipLoader from 'react-spinners/ClipLoader';
import Loader from '../components/Loader';
import clsx from 'clsx';
import Masonry from 'react-masonry-css';
import TwigCard from '../components/TwigCard';
import { Twig, Product, Category, Brand, Business } from '../types';
import { listTwigs, listOptionTwigs } from '../services/TwigService';
import { listProducts, listOptionProducts } from '../services/productService';
import Select from 'react-select';
import {getAllCategories} from '../services/ApiService';
import { MdSearch } from "react-icons/md";
import ProductCard from '../components/ProductCard';
import { useLoadMore } from '../lib/hooks';
import { BsFilter } from 'react-icons/bs';
import { AiOutlineClose } from 'react-icons/ai';
import { FiChevronRight } from "react-icons/fi";
import  Redirect from 'react-router';


import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css'
import { generatePath } from 'react-router';
import { Link } from 'react-router-dom';
import { pageTrack, track } from '../services/mixpanelService';
import { Accordion, Button } from 'react-bootstrap';
const queryString = require('query-string');

export interface SearchProps {
  history: any,
  
}
const Search: React.FC<SearchProps> = ({ history }) => {

  const classes = useStyles();
  const getKey = function (key: string, url: string = "") {
    if (url == "" && history?.location?.search) {
      url = history.location.search
    }
    if (url.indexOf(key) == -1) {
      return ""
    }
    let keyIndex = url.indexOf(key) + key.length + 1
    url = url.substring(keyIndex)
    let charIndex = url.indexOf("&");
    if (charIndex == -1)
      charIndex = url.length
    let value = url
    if (key == "option") {
      const parsed = queryString.parse(history.location.search, { parseNumbers: true });
      let tempValue = Array.isArray(parsed["option"]) ? parsed["option"] : [];
      //convert the object to string 
      return JSON.stringify(tempValue);
    }
    value = value.substring(0, charIndex)
    return value
  }
  let searchKeyVar = ""
  if (history?.location?.search != "" && history?.location?.search != "") {
    searchKeyVar = getKey("searchKey")
  }


  const [searchKey, setSearchKey] = useState(decodeURIComponent(searchKeyVar));
  const [viewFilter, setViewFilter] = useState(false);
  const [selectedTab, setSelectedTab] = useState(getKey("tab") == "" ? 'products' : getKey("tab"));
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState<Product[]>([]);
  const [offers, setOffers] = useState<Product[]>([]);
  const [twigs, setTwigs] = useState<Twig[]>([]);
  const [breadCrumb, setBreadCrumb] = useState<Object[]>([]);
  const [defaultActiveKey, setDefaultActiveKey] = useState<string>("");




  const [productSubcategories, setProductSubcategories] = useState<any[]>([]);
  const [productCategories, setProductCategories] = useState<any[]>([]);
  const [productBrands, setProductBrands] = useState<any[]>([]);
  const [productBusinesses, setProductBusinesses] = useState<any[]>([]);
  const [productTotalCount, setProductTotalCount] = useState<number>(0);
  const [productSelectedBrand, setProductSelectedBrand] = useState<Brand | null>();
  const [productSelectedBusiness, setProductSelectedBusiness] = useState<Business | null>();
  const [productSelectedCategory, setProductSelectedCategory] = useState<Category | null>();
  const [productSelectedSubcategory, setProductSelectedSubcategory] = useState<Category | null>();
  const [productCategoryId, setProductCategoryId] = useState<number | null>(getKey("categoryId") ? +getKey("categoryId") : null);
  const [productGenders, setProductGenders] = useState<any[]>([]);
  const [productGender, setProductGender] = useState<string | null>(getKey("gender") ? getKey("gender") : null);
  const [productSubcategoryId, setProductSubcategoryId] = useState<number | null>(getKey("subCategoryId") ? +getKey("subCategoryId") : null);
  const [productBrandId, setProductBrandId] = useState<number | null>(getKey("brandId") ? +getKey("brandId") : null);
  const [productBusinessId, setProductBusinessId] = useState<number | null>(getKey("businessId") ? +getKey("businessId") : null);
  const [rangProductPrice, setRangProductPrice] = useState<any>({ "min": getKey("min_price") == "" ? 0 : +getKey("min_price"), "max": getKey("max_price") == "" ? 500 : +getKey("max_price") });
  const [rangProductPriceChanged, setRangProductPriceChanged] = useState<number>(getKey("min_price") ? 1 : 0);
  const [productPrice, setProductPrice] = useState<any>({ "min": getKey("min_price") == "" ? 0 : getKey("min_price"), "max": getKey("max_price") == "" ? 500 : +getKey("max_price") });
  const [productsOption, setProductsOption] = useState<any[]>([]);
  const [productsOptionIds, setProductsOptionIds] = useState<any[]>(getKey("option") == "" ? [] : JSON.parse(getKey("option")));
  const [productsOptionSelected, setProductsOptionSelected] = useState<any[]>([]);
  const [productSearchBrand, setProductSearchBrand] = useState<string>("");
  const [productSearchBusiness, setProductSearchBusiness] = useState<string>("");
  const [productTags, setProductTags] = useState<string>(getKey("tags") != "" ? getKey("tags") : "");


  const [twigSelectedBusiness, setTwigSelectedBusiness] = useState<Business | null>();
  const [twigBusinessId, setTwigBusinessId] = useState<number | null>(getKey("businessId") ? +getKey("businessId") : null);
  const [twigSearchBusiness, setTwigSearchBusiness] = useState<string>("");
  const [twigBusinesses, setTwigBusinesses] = useState<any[]>([]);
  const [twigSubcategories, setTwigSubcategories] = useState<any[]>([]);
  const [twigCategories, setTwigCategories] = useState<any[]>([]);
  const [twigBrands, setTwigBrands] = useState<any[]>([]);
  const [twigTotalCount, setTwigTotalCount] = useState<number>(0);
  const [twigSelectedBrand, setTwigSelectedBrand] = useState<Brand | null>();
  const [twigSelectedCategory, setTwigSelectedCategory] = useState<Category | null>();
  const [twigSelectedSubcategory, setTwigSelectedSubcategory] = useState<Category | null>();
  const [twigCategoryId, setTwigCategoryId] = useState<number | null>(getKey("categoryId") ? +getKey("categoryId") : null);
  const [twigGenders, setTwigGenders] = useState<any[]>([]);
  const [twigGender, setTwigGender] = useState<string | null>(getKey("gender") ? getKey("gender") : null);
  const [twigSubcategoryId, setTwigSubcategoryId] = useState<number | null>(getKey("subCategoryId") ? +getKey("subCategoryId") : null);
  const [twigBrandId, setTwigBrandId] = useState<number | null>(getKey("brandId") ? +getKey("brandId") : null);
  const [rangTwigPrice, setRangTwigPrice] = useState<any>({ "min": getKey("min_price") == "" ? 0 : +getKey("min_price"), "max": getKey("max_price") == "" ? 500 : +getKey("max_price") });
  const [rangTwigPriceChanged, setRangTwigPriceChanged] = useState<number>(getKey("min_price") ? 1 : 0);
  const [twigPrice, setTwigPrice] = useState<any>({ "min": getKey("min_price") == "" ? 0 : +getKey("min_price"), "max": getKey("max_price") == "" ? 500 : +getKey("max_price") });
  const [twigsOption, setTwigsOption] = useState<any[]>([]);
  const [twigsOptionIds, setTwigsOptionIds] = useState<any[]>(getKey("option") == "" ? [] : JSON.parse(getKey("option")));
  const [twigsOptionSelected, setTwigsOptionSelected] = useState<any[]>([]);
  const [twigSearchBrand, setTwigSearchBrand] = useState<string>("");
  const [twigTags, setTwigTags] = useState<string>(getKey("tags") != "" ? getKey("tags") : "");


  const [offerSelectedBusiness, setOfferSelectedBusiness] = useState<Business | null>();
  const [offerBusinessId, setOfferBusinessId] = useState<number | null>(getKey("businessId") ? +getKey("businessId") : null);
  const [offerSearchBusiness, setOfferSearchBusiness] = useState<string>("");
  const [offerBusinesses, setOfferBusinesses] = useState<any[]>([]);
  const [offerSubcategories, setOfferSubcategories] = useState<any[]>([]);
  const [offerCategories, setOfferCategories] = useState<any[]>([]);
  const [offerBrands, setOfferBrands] = useState<any[]>([]);
  const [offerTotalCount, setOfferTotalCount] = useState<number>(0);
  const [offerSelectedBrand, setOfferSelectedBrand] = useState<Brand | null>();
  const [offerSelectedCategory, setOfferSelectedCategory] = useState<Category | null>();
  const [offerSelectedSubcategory, setOfferSelectedSubcategory] = useState<Category | null>();
  const [offerCategoryId, setOfferCategoryId] = useState<number | null>(getKey("categoryId") ? +getKey("categoryId") : null);
  const [offerGenders, setOfferGenders] = useState<any[]>([]);
  const [offerGender, setOfferGender] = useState<string | null>(getKey("gender") ? getKey("gender") : null);
  const [offerSubcategoryId, setOfferSubcategoryId] = useState<number | null>(getKey("subCategoryId") ? +getKey("subCategoryId") : null);
  const [offerBrandId, setOfferBrandId] = useState<number | null>(getKey("brandId") ? +getKey("brandId") : null);
  const [rangOfferPrice, setRangOfferPrice] = useState<any>({ "min": getKey("min_price") == "" ? 0 : +getKey("min_price"), "max": getKey("max_price") == "" ? 500 : +getKey("max_price") });
  const [rangOfferPriceChanged, setRangOfferPriceChanged] = useState<number>(getKey("min_price") ? 1 : 0);
  const [offerPrice, setOfferPrice] = useState<any>({ "min": getKey("min_price") == "" ? 0 : +getKey("min_price"), "max": getKey("max_price") == "" ? 500 : +getKey("max_price") });
  const [offersOption, setOffersOption] = useState<any[]>([]);
  const [offersOptionIds, setOffersOptionIds] = useState<any[]>(getKey("option") == "" ? [] : JSON.parse(getKey("option")));
  const [offersOptionSelected, setOffersOptionSelected] = useState<any[]>([]);
  const [offerSearchBrand, setOfferSearchBrand] = useState<string>("");
  const [offerTags, setOfferTags] = useState<string>(getKey("tags") != "" ? getKey("tags") : "");









  const [loadingMore, setLoadingMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [doInfiniteScroll, setDoInfiniteScroll] = useState(false);
  const endReached = useLoadMore();


  const [loadingMoreProduct, setLoadingMoreProduct] = useState(false);
  const [currentPageProduct, setCurrentPageProduct] = useState(1);
  const [hasMoreProduct, setHasMoreProduct] = useState(true);
  const [doInfiniteScrollProduct, setDoInfiniteScrollProduct] = useState(false);
  const endReachedProduct = useLoadMore();


  const [loadingMoreOffer, setLoadingMoreOffer] = useState(false);
  const [currentPageOffer, setCurrentPageOffer] = useState(1);
  const [hasMoreOffer, setHasMoreOffer] = useState(true);
  const [doInfiniteScrollOffer, setDoInfiniteScrollOffer] = useState(false);
  const endReachedOffer = useLoadMore();










  useEffect(() => {
    pageTrack("search_screen");
     

    let curentProductSubcategoryId = productSubcategoryId
    let curentProductCategoryId = productCategoryId
    let curentProductGender = productGender
    let curentProductBrandId = productBrandId
    let curentProductBusinessId = productBusinessId
    let currentProductTags = productTags
   
    let curentOfferSubcategoryId = offerSubcategoryId
    let curentOfferCategoryId = offerCategoryId
    let curentOfferGender = offerGender
    let curentOfferBrandId = offerBrandId
    let curentOfferBusinessId = offerBusinessId


    let curentTwigSubcategoryId = offerSubcategoryId
    let curentTwigCategoryId = twigCategoryId
    let curentTwigGender = twigGender
    let curentTwigBrandId = twigBrandId
    let curentTwigBusinessId = twigBusinessId

    let curentTab: string = "";

    
    let productCategoryIdVar: number | null;
    let productSubcategoryIdVar: number | null;
    let productBrandIdVar: number | null;
    let productBusinessIdVar: number | null;
    let productGenderVar: string | null;
    let productOptionIds: number[];
    let productTagsVar: string |null;


    let twigSubcategoryIdVar: number | null;
    let twigCategoryIdVar: number | null;
    let twigBrandIdVar: number | null;
    let twigBusinessIdVar: number | null;
    let twigGenderVar: string | null;
    let twigOptionIds: number[];

    let twigTagsVar: string | null;

    let offerCategoryIdVar: number | null;
    let offerSubcategoryIdVar: number | null;
    let offerBusinessIdVar: number | null;
    let offerBrandIdVar: number | null;
    let offerGenderVar: string | null;
    let offerOptionIds: number[];
    let offerTagsVar: string | null;

    track("view_search_results")

    history.listen((location: any, action: any) => {
       
      curentTab = getKey("tab") == "" ? 'products' : getKey("tab");
      
      let searchKeyVar = location.search.substring(history.location.search.indexOf("searchKey=") + 10, history.location.search.indexOf("&"))
      if (curentTab == "products") {
        productCategoryIdVar = +getKey("categoryId");
        if(getKey("categoryId") != ""){
          setProductCategoryId(productCategoryIdVar);
          setTwigCategoryId(productCategoryIdVar);
          setOfferCategoryId(productCategoryIdVar);
        } 
        
        productSubcategoryIdVar = +getKey("subCategoryId");
        productBrandIdVar = +getKey("brandId")
        productBusinessIdVar = +getKey("businessId");
        if(getKey("businessId") != ""){
          setProductBusinessId(productBusinessIdVar);
        }
        productGenderVar = getKey("gender") == "" ? null : getKey("gender");
        productTagsVar = getKey("tags") == "" ? null : getKey("tags");
        productCategoryIdVar = productCategoryIdVar == 0 ? null : productCategoryIdVar
        productSubcategoryIdVar = productSubcategoryIdVar == 0 ? null : productSubcategoryIdVar
        productBrandIdVar = productBrandIdVar == 0 ? null : productBrandIdVar
        productBusinessIdVar = productBusinessIdVar == 0 ? null : productBusinessIdVar;
        productOptionIds = getKey("option") == "" ? [] : JSON.parse(getKey("option"));


      } else if (curentTab == "twigs") {

        twigSubcategoryIdVar = +getKey("subCategoryId")
        twigCategoryIdVar = +getKey("categoryId")
        if(getKey("categoryId")!=""){
          setTwigCategoryId(twigCategoryIdVar)
        }
        twigBusinessIdVar = +getKey("businessId");
        twigBrandIdVar = +getKey("brandId")
        twigTagsVar = getKey("tags") == "" ? null : getKey("tags");
        twigGenderVar = getKey("gender") == "" ? null : getKey("gender")
        twigCategoryIdVar = twigCategoryIdVar == 0 ? null : twigCategoryIdVar
        twigSubcategoryIdVar = twigSubcategoryIdVar == 0 ? null : twigSubcategoryIdVar
        twigBrandIdVar = twigBrandIdVar == 0 ? null : twigBrandIdVar
        twigBusinessIdVar = twigBusinessIdVar == 0 ? null : twigBusinessIdVar
        twigOptionIds = getKey("option") == "" ? [] : JSON.parse(getKey("option"));

        
      }
      else if (curentTab == "offers") {

        offerCategoryIdVar = +getKey("categoryId")
        if(getKey("categoryId")!=""){
          setOfferCategoryId(offerCategoryIdVar);
        }
        offerSubcategoryIdVar = +getKey("subCategoryId");
        offerBusinessIdVar = +getKey("businessId");
        offerBrandIdVar = +getKey("brandId")
        offerTagsVar = getKey("tags") == "" ? null : getKey("tags")
        offerGenderVar = getKey("gender") == "" ? null : getKey("gender");

        offerCategoryIdVar = offerCategoryIdVar == 0 ? null : offerCategoryIdVar
        offerSubcategoryIdVar = offerSubcategoryIdVar == 0 ? null : offerSubcategoryIdVar
        offerBrandIdVar = offerBrandIdVar == 0 ? null : offerBrandIdVar
        offerBusinessIdVar = offerBusinessIdVar == 0 ? null : offerBusinessIdVar
        offerOptionIds = getKey("option") == "" ? [] : JSON.parse(getKey("option"))
      }





      if (searchKeyVar != searchKey || searchKeyVar == "") {
        searchKeyVar = decodeURIComponent(searchKeyVar)
        setSearchKey(searchKeyVar)
      }
      if (curentTab == 'products') {
        if (productSubcategoryIdVar != curentProductSubcategoryId) {
          setSelectedTab(curentTab)
          curentProductSubcategoryId = productSubcategoryIdVar
          setProductCategoryId(productCategoryIdVar);
          setProductBusinessId(null)
          setProductSubcategoryId(productSubcategoryIdVar)
          setProductBrandId(null)
          setProductSelectedBrand(null)
          setProductsOptionIds([])
          setRangProductPriceChanged(0)
          setProductGender(null)
        } else if (productCategoryIdVar != curentProductCategoryId) {
          setSelectedTab(curentTab)
          curentProductCategoryId = productCategoryIdVar
          setProductCategoryId(productCategoryIdVar)
          setProductBusinessId(null)
          setProductSelectedSubcategory(null)
          setProductSubcategoryId(null)
          setProductBrandId(null)
          setProductSelectedBrand(null)
          setProductsOptionIds([])
          setRangProductPriceChanged(0)
          setProductGender(null)
        }
        else if (productGenderVar != curentProductGender && productGenderVar != null) {
          curentProductGender = productGenderVar
          setProductGender(productGenderVar)
          // setProductBusinessId(productBusinessId)
          setSelectedTab(curentTab)
          setProductSelectedSubcategory(null)
          // setProductSubcategoryId(productSubcategoryId)
          // setProductBrandId(productBrandId)
          setProductSelectedBrand(null)
          // setProductsOptionIds(productsOptionIds)
          // setRangProductPriceChanged(0)
          // setProductCategoryId(productCategoryId)
        }
        else if (productBrandIdVar != curentProductBrandId) {
          curentProductBrandId = productBrandIdVar
          // setProductBusinessId(productBusinessIdVar)
          setProductBrandId(productBrandIdVar)
          setSelectedTab(curentTab)
          // setProductSelectedSubcategory(null)
          // setProductSubcategoryId(productSubcategoryId)
          // setProductGender(productGender)
          setProductSelectedBrand(null)
          // setProductsOptionIds(productOptionIds)
          // setRangProductPriceChanged(0)
          // setProductCategoryId(productCategoryId)
        } else if (productBusinessIdVar != curentProductBusinessId) {
          curentProductBusinessId = productBusinessIdVar
          setProductBusinessId(productBusinessIdVar)
          setProductBrandId(productBrandIdVar)
          setSelectedTab(curentTab)
          setProductSelectedSubcategory(null)
          setProductSubcategoryId(productSubcategoryId)
          setProductGender(productGender)
          setProductSelectedBrand(null)
          setProductsOptionIds(productOptionIds)
          setRangProductPriceChanged(0)
          setProductCategoryId(null)
        }
      }
      else if (curentTab == 'twigs') {
        if (twigSubcategoryIdVar != curentTwigSubcategoryId) {
          curentTwigSubcategoryId = twigSubcategoryIdVar
          setTwigSubcategoryId(twigSubcategoryIdVar)
          setTwigBusinessId(null)
          setTwigCategoryId(twigCategoryIdVar)
          setTwigSelectedSubcategory(null)
          setSelectedTab(curentTab)
          setTwigSubcategoryId(null)
          setTwigBrandId(null)
          setTwigSelectedBrand(null)
          setTwigsOptionIds([])
          setRangTwigPriceChanged(0)
          setTwigGender(null)
        }
        else if (twigCategoryIdVar != curentTwigCategoryId) {
          curentTwigCategoryId = twigCategoryIdVar
          setTwigCategoryId(twigCategoryIdVar)
          setTwigBusinessId(null)
          setTwigSelectedSubcategory(null)
          setSelectedTab(curentTab)
          setTwigSubcategoryId(null)
          setTwigBrandId(null)
          setTwigSelectedBrand(null)
          setTwigsOptionIds([])
          setRangTwigPriceChanged(0)
          setTwigGender(null)
        }
        else if (twigGenderVar != curentTwigGender) {
          curentTwigGender = twigGenderVar
          setTwigGender(twigGenderVar)
          setSelectedTab(curentTab)
          // setTwigBusinessId(twigBusinessIdVar)
          setTwigSelectedSubcategory(null)
          // setTwigSubcategoryId(twigSubcategoryId)
          // setTwigBrandId(twigBrandId)
          setTwigSelectedBrand(null)
          // setTwigsOptionIds(twigOptionIds)
          // setRangTwigPriceChanged(0)
          // setTwigCategoryId(twigCategoryId)
        }
        else if (twigBrandIdVar != curentTwigBrandId) {
          curentTwigBrandId = twigBrandIdVar
          // setTwigGender(twigGender)
          setSelectedTab(curentTab)
          setTwigSelectedSubcategory(null)
          // setTwigBusinessId(twigBusinessIdVar)
          // setTwigSubcategoryId(twigSubcategoryId)
          setTwigBrandId(twigBrandIdVar)
          setTwigSelectedBrand(null)
          // setTwigsOptionIds(twigOptionIds)
          // setRangTwigPriceChanged(0)
          // setTwigCategoryId(twigCategoryId)
        }
        else if (twigBusinessIdVar != curentTwigBusinessId) {
          curentTwigBusinessId = twigBusinessIdVar
          // setTwigGender(twigGender)
          setSelectedTab(curentTab)
          setTwigSelectedSubcategory(null)
          setTwigBusinessId(twigBusinessIdVar)
          // setTwigSubcategoryId(twigSubcategoryId)
          // setTwigBrandId(twigBrandIdVar)
          setTwigSelectedBrand(null)
          // setTwigsOptionIds(twigOptionIds)
          // setRangTwigPriceChanged(0)
          // setTwigCategoryId(twigCategoryId)
        }
      }
      else if (curentTab == 'offers') {
        if (offerSubcategoryIdVar != curentOfferSubcategoryId) {
          curentOfferSubcategoryId = offerSubcategoryIdVar
          setOfferCategoryId(offerCategoryIdVar)
          setOfferSubcategoryId(offerSubcategoryIdVar)
          setOfferBusinessId(null)
          setSelectedTab(curentTab)
          setOfferSelectedSubcategory(null)
          setOfferSubcategoryId(null)
          setOfferBrandId(null)
          setOfferSelectedBrand(null)
          setOffersOptionIds([])
          setRangOfferPriceChanged(0)
          setOfferGender(null)
        }
        else if (offerCategoryIdVar != curentOfferCategoryId) {
          curentOfferCategoryId = offerCategoryIdVar
          setOfferCategoryId(offerCategoryIdVar)
          setSelectedTab(curentTab)
          setOfferBusinessId(null)
          setOfferSelectedSubcategory(null)
          setOfferSubcategoryId(null)
          setOfferBrandId(null)
          setOfferSelectedBrand(null)
          setOffersOptionIds([])
          setRangOfferPriceChanged(0)
          setOfferGender(null)
        }
        else if (offerGenderVar != curentOfferGender) {
          curentOfferGender = offerGenderVar
          // setOfferBusinessId(offerBusinessIdVar)
          setOfferGender(offerGenderVar)
          setOfferSelectedSubcategory(null)
          // setOfferSubcategoryId(offerSubcategoryId)
          setSelectedTab(curentTab)
          // setOfferBrandId(offerBrandId)
          setOfferSelectedBrand(null)
          // setOffersOptionIds(offerOptionIds)
          // setRangOfferPriceChanged(0)
          setOfferCategoryId(null)
        }
        else if (offerBrandIdVar != curentOfferBrandId) {
          curentOfferBrandId = offerBrandIdVar
          // setOfferGender(offerGender)
          // setOfferBusinessId(offerBusinessIdVar)
          setOfferSelectedSubcategory(null)
          // setOfferSubcategoryId(offerSubcategoryId)
          setSelectedTab(curentTab)
          setOfferBrandId(offerBrandIdVar)
          setOfferSelectedBrand(null)
          // setOffersOptionIds(offerOptionIds)
          // setRangOfferPriceChanged(0)
          // setOfferCategoryId(offerCategoryId)
        }
        else if (offerBusinessIdVar != curentOfferBusinessId) {
          curentOfferBusinessId = offerBusinessIdVar
          // setOfferGender(offerGender)
          setOfferBusinessId(offerBusinessIdVar)
          setOfferSelectedSubcategory(null)
          // setOfferSubcategoryId(offerSubcategoryId)
          setSelectedTab(curentTab)
          // setOfferBrandId(offerBrandId)
          setOfferSelectedBrand(null)
          // setOffersOptionIds(offerOptionIds)
          // setRangOfferPriceChanged(0)
          // setOfferCategoryId(offerCategoryId)
        }
      }
    });

  }, []);






  useEffect(() => {
    if (!doInfiniteScrollProduct || !hasMoreProduct || !endReachedProduct || loadingMoreProduct || loading || selectedTab != 'products') return;
    (async () => {
      setLoadingMoreProduct(true);
      try {
        var filterParams = "keyword=" + searchKey + "&"

        if (rangProductPriceChanged != 0) {
          filterParams += "max_price=" + productPrice.max + "&min_price=" + productPrice.min + "&"
        }
        if (productBrandId)
          filterParams += "&brand_id=" + productBrandId + "&";

        if (productCategoryId)
          filterParams += "category_id=" + productCategoryId + "&"
        if (productBusinessId)
          filterParams += "business_id=" + productBusinessId + "&"
        if (productSubcategoryId)
          filterParams += "sub_category_id=" + productSubcategoryId + "&"
        if (productGender)
          filterParams += "gender=" + productGender + "&"

        productsOptionIds.forEach(element => {
          filterParams += "option_values[]=" + element + "&"
        });

        if (productTags) {
          let arrayProductTags = productTags.split(",");
          for (let index = 0; index < arrayProductTags.length; index++) {
            const element = arrayProductTags[index];
            filterParams += "tagnames[" + index + "]=" + element + "&";
          }
        }

        if (filterParams.length != 1)
          filterParams += "&"
        var { products: response, pagination } = await listProducts(currentPageProduct, 24, filterParams);

        setProducts([...products, ...response]);
        if (response.length < 10) {
          setHasMoreProduct(false);
        } else {
          setCurrentPageProduct(currentPageProduct + 1);
        }
      } catch (e) {
        console.error(e);
      }
      setLoadingMoreProduct(false);
    })();
  }, [doInfiniteScrollProduct, hasMoreProduct, currentPageProduct, endReachedProduct, loadingMoreProduct, products]);


  useEffect(() => {
    if (!doInfiniteScrollOffer || !hasMoreOffer || !endReachedOffer || loadingMoreOffer || loading || selectedTab != 'offers') return;
    (async () => {
      setLoadingMoreOffer(true);
      try {
        var filterParams = "keyword=" + searchKey + "&is_offer=1&"

        if (rangOfferPriceChanged != 0) {
          filterParams += "max_price=" + offerPrice.max + "&min_price=" + offerPrice.min + "&"
        }
        if (offerCategoryId)
          filterParams += "category_id=" + offerCategoryId + "&"
        if (offerSubcategoryId)
          filterParams += "sub_category_id=" + offerSubcategoryId + "&"
        if (offerBusinessId)
          filterParams += "business_id=" + offerBusinessId + "&"

        if (offerGender)
          filterParams += "gender=" + offerGender + "&"
        for (const key in offersOptionSelected) {
          if (Object.prototype.hasOwnProperty.call(offersOptionSelected, key)) {
            const element = offersOptionSelected[key];
            if (element)
              filterParams += "option_values[]=" + element.id + "&"
          }
        }

        offersOptionIds.forEach(element => {
          filterParams += "option_values[]=" + element + "&"
        });

        if (offerTags) {
          let arrayTwigTags = offerTags.split(",");
          for (let index = 0; index < arrayTwigTags.length; index++) {
            const element = arrayTwigTags[index];
            filterParams += "tagnames[" + index + "]=" + element + "&";
          }
        }

        if (filterParams.length != 1)
          filterParams += "&"

        var { products: response, pagination } = await listProducts(currentPageOffer, 24, filterParams);

        setOffers([...offers, ...response]);
        if (response.length < 10) {
          setHasMoreOffer(false);
        } else {
          setCurrentPageOffer(currentPageOffer + 1);
        }
      } catch (e) {
        console.error(e);
      }
      setLoadingMoreOffer(false);
    })();
  }, [doInfiniteScrollOffer, hasMoreOffer, currentPageOffer, endReachedOffer, loadingMoreOffer, offers]);


  useEffect(() => {
    if (!doInfiniteScroll || !hasMore || !endReached || loadingMore || loading || selectedTab != 'twigs') return;
    (async () => {
      setLoadingMore(true);
      var filterParams = "keyword=" + searchKey + "&"
      if (rangTwigPriceChanged != 0) {
        filterParams += "max_price=" + twigPrice.max + "&min_price=" + twigPrice.min + "&"
      }
      if (twigCategoryId)
        filterParams += "category_id=" + twigCategoryId + "&"
      if (twigBrandId)
        filterParams += "brand_id=" + twigBrandId + "&"
      if (twigSubcategoryId)
        filterParams += "sub_category_id=" + twigSubcategoryId + "&"
      if (twigGender)
        filterParams += "gender=" + twigGender + "&"
      if (twigBusinessId)
        filterParams += "business_id=" + twigBusinessId + "&"


      twigsOptionIds.forEach(element => {
        filterParams += "option_values[]=" + element + "&"
      });

      if (twigTags) {
        let arrayTwigTags = twigTags.split(",");
        for (let index = 0; index < arrayTwigTags.length; index++) {
          const element = arrayTwigTags[index];
          filterParams += "tagnames[" + index + "]=" + element + "&";
        }
      }

      if (filterParams.length != 1)
        filterParams += "&"
      try {

        var { twigs: response, pagination } = await listTwigs(currentPage, 24, filterParams);

        setTwigs([...twigs, ...response]);
        if (response.length < 10) {
          setHasMore(false);
        } else {
          setCurrentPage(currentPage + 1);
        }
      } catch (e) {
        console.error(e);
      }
      setLoadingMore(false);
    })();
  }, [doInfiniteScroll, hasMore, currentPage, endReached, loadingMore, twigs]);



  const openFilter = useCallback(() => {
    setViewFilter(true);
    track("filter_icon")
  }, [])


  const handleChangeTab = useCallback(
    (tab) => {
      setSelectedTab(tab);
      let path = "";
      // let selectedCategory : Category | undefined;
      if (tab == "products") {

        path = "/search?searchKey=" + searchKey + "&tab=" + tab + "&" + queryString.stringify({ option: productsOptionIds }) + "&";
       

         if(productCategoryId){
          path += "&categoryId=" + productCategoryId;
         }
    

        if (rangProductPriceChanged != 0) {
          path += "min_price=" + productPrice.min + "&max_price=" + productPrice.max + "&"
        }
        
        if (productBusinessId)
          path += "&businessId=" + productBusinessId;
        if (productTags)
          path += "&tags=" + productTags;
        if (productSubcategoryId)
          path += "&subCategoryId=" + productSubcategoryId
        if (productGender)
          path += "&gender=" + productGender

        if (selectedTab == "offers") {
          setRangProductPrice(rangOfferPrice)
          setRangProductPriceChanged(rangOfferPriceChanged)
          setProductPrice(rangOfferPrice)
        } else if (selectedTab == "twigs") {
          setProductPrice(rangTwigPrice)
          setRangProductPriceChanged(rangTwigPriceChanged)
          setProductPrice(rangTwigPrice)
        }

      }
      else if (tab == "twigs") {
        path = "/search?searchKey=" + searchKey + "&tab=" + tab + "&" + queryString.stringify({ option: twigsOptionIds }) + "&";
        if(twigCategoryId){
          path += "&categoryId=" + twigCategoryId;
        }
       

        if (rangTwigPriceChanged != 0) {
          path += "min_price=" + twigPrice.min + "&max_price=" + twigPrice.max + "&"
        }
        if (twigSubcategoryId)
          path += "&subCategoryId=" + twigSubcategoryId
        if (twigGender)
          path += "&gender=" + twigGender
        if (twigTags)
          path += "&tags=" + twigTags
        if (twigBusinessId)
          path += "&businessId=" + twigBusinessId;
        if (selectedTab == "products") {
          setRangTwigPrice(rangProductPrice)
          setRangTwigPriceChanged(rangProductPriceChanged)
          setTwigPrice(rangProductPrice)
        } else if (selectedTab == "offers") {
          setRangTwigPrice(rangOfferPrice)
          setRangTwigPriceChanged(rangOfferPriceChanged)
          setTwigPrice(rangOfferPrice)
        }
      }
      else if (tab == "offers") {

    path = "/search?searchKey=" + searchKey + "&tab=" + tab + "&" + queryString.stringify({ option: offersOptionIds }) + "&";
 
    if(offerCategoryId){
      path += "&categoryId=" + offerCategoryId;
    }
    if (rangOfferPriceChanged != 0) {
      path += "min_price=" + offerPrice.min + "&max_price=" + offerPrice.max + "&"
    }

        if (offerSubcategoryId)
          path += "&subCategoryId=" + offerSubcategoryId

        if (offerGender)
          path += "&gender=" + offerGender
        if (offerTags)
          path += "&tags=" + offerTags
        if (offerBusinessId)
          path += "&businessId=" + offerBusinessId;

        if (selectedTab == "products") {
          setRangOfferPrice(rangProductPrice)
          setRangOfferPriceChanged(rangProductPriceChanged)
          setOfferPrice(rangProductPrice)
        } else if (selectedTab == "twigs") {
          setRangOfferPrice(rangTwigPrice)
          setRangOfferPriceChanged(rangTwigPriceChanged)
          setOfferPrice(rangTwigPrice)
        }

      }
      history.push(path);
    },
    [searchKey,productGender,twigGender,offerGender, productSubcategoryId, offerSubcategoryId, twigSubcategoryId, productTags, twigTags, offerTags, productBusinessId, twigBusinessId, offerBusinessId, productCategoryId, offerCategoryId, twigCategoryId, productPrice, offerPrice, twigPrice, productsOptionIds, offersOptionIds, twigsOptionIds],
  );


  const clearSearchKey = useCallback(
    () => {
      let allParam = history.location.search.substring(history.location.search.indexOf("&"))
      history.push('/search?searchKey=' + allParam)
    },
    [],
  );



  const deleteProductsOption = useCallback(
    (optionId) => {
      // let tempProductsOptionSelected = productsOptionSelected.slice(0);
      // delete tempProductsOptionSelected[index]
      // setProductsOptionSelected(tempProductsOptionSelected)
      // let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&option=" + JSON.stringify(tempProductsOptionSelected)

      let tempProductsOptionIds = productsOptionIds.slice(0);
      if (tempProductsOptionIds.indexOf(optionId) != -1) {
        tempProductsOptionIds.splice(tempProductsOptionIds.indexOf(optionId), 1)
      }
      let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: tempProductsOptionIds });  //option=" + JSON.stringify(tempProductsOptionSelected)

      setProductsOptionIds(tempProductsOptionIds)
      if (rangProductPriceChanged != 0) {
        path += "&min_price=" + productPrice.min + "&max_price=" + productPrice.max
      }

      if (productBusinessId)
        path += "&businessId=" + productBusinessId;
      if (productBrandId)
        path += "&brandId=" + productBrandId;
      if (productCategoryId)
        path += "&categoryId=" + productCategoryId;
      if (productSubcategoryId)
        path += "&subCategoryId=" + productSubcategoryId
      if (productGender)
        path += "&gender=" + productGender
      if (productTags)
        path += "&tags=" + productTags;
      history.push(path);


    },
    [productsOptionIds],
  );

  const deleteProductsPrice = useCallback(() => {
    setRangProductPriceChanged(0)
    setRangTwigPriceChanged(0)
    setRangOfferPriceChanged(0)
    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&option=" + JSON.stringify(productsOptionSelected)

    if (productBusinessId)
      path += "&businessId=" + productBusinessId;
    if (productBrandId)
      path += "&brandId=" + productBrandId;
    if (productCategoryId)
      path += "&categoryId=" + productCategoryId;
    if (productSubcategoryId)
      path += "&subCategoryId=" + productSubcategoryId
    if (productGender)
      path += "&gender=" + productGender
    if (productTags)
      path += "&tags=" + productTags;
    history.push(path);

  },
    [productPrice],
  )
  const handelChangeProductsPrice = useCallback((value: any) => {
    setRangProductPriceChanged(rangProductPriceChanged + 1)

    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&min_price=" + value.min + "&max_price=" + value.max + "&option=" + JSON.stringify(productsOptionSelected)

    if (productBusinessId)
      path += "&businessId=" + productBusinessId;
    if (productBrandId)
      path += "&brandId=" + productBrandId;
    if (productCategoryId)
      path += "&categoryId=" + productCategoryId;
    if (productSubcategoryId)
      path += "&subCategoryId=" + productSubcategoryId
    if (productGender)
      path += "&gender=" + productGender
    if (productTags)
      path += "&tags=" + productTags;

    history.push(path);
  },
    [productPrice],
  )


  const handleChangeProductFilter = useCallback((x: number, y: any) => {
    let tempProductsOptionIds = productsOptionIds.slice(0);
    if (y != null) {
      tempProductsOptionIds.push(y.id);
      if (productsOptionSelected[x]) {
        tempProductsOptionIds.splice(tempProductsOptionIds.indexOf(productsOptionSelected[x].id), 1)
      }
    } else if (y == null || tempProductsOptionIds.indexOf(y) != -1) {
      tempProductsOptionIds.splice(tempProductsOptionIds.indexOf(y), 1)
    }
    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: tempProductsOptionIds });  //option=" + JSON.stringify(tempProductsOptionSelected)
    if (rangProductPriceChanged != 0) {
      path += "&min_price=" + productPrice.min + "&max_price=" + productPrice.max
    }
    if (productBusinessId)
      path += "&businessId=" + productBusinessId;
    if (productBrandId)
      path += "&brandId=" + productBrandId;
    if (productCategoryId)
      path += "&categoryId=" + productCategoryId;
    if (productSubcategoryId)
      path += "&subCategoryId=" + productSubcategoryId
    if (productGender)
      path += "&gender=" + productGender
    if (productTags)
      path += "&tags=" + productTags;

    setProductsOptionIds(tempProductsOptionIds)
    setOffersOptionIds(tempProductsOptionIds)
    setTwigsOptionIds(tempProductsOptionIds)
    history.push(path);

  },
    [productsOptionIds, productsOptionSelected],
  );



  const handleChangeProductsTag = useCallback((tag) => {
    let newTags = productTags.split(",");
    newTags.splice(newTags.indexOf(tag), 1);
    let newTagsString: string = newTags.join();
    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: productsOptionIds })
    if (rangProductPriceChanged != 0) {
      path += "&min_price=" + productPrice.min + "&max_price=" + productPrice.max
    }

    if (productBusinessId)
      path += "&businessId=" + productBusinessId;
    if (productBrandId)
      path += "&brandId=" + productBrandId;
    if (productCategoryId)
      path += "&categoryId=" + productCategoryId;
    if (productSubcategoryId)
      path += "&subCategoryId=" + productSubcategoryId
    if (productGender)
      path += "&gender=" + productGender
    if (newTagsString)
      path += "&tags=" + newTagsString;

    setProductTags(newTagsString)
    setTwigTags(newTagsString)
    setOfferTags(newTagsString)
    history.push(path);
  },
    [productTags],
  );


  const handleChangeProductGender = useCallback((gender) => {
    setProductGender(gender)
    setTwigGender(gender)
    setOfferGender(gender)

    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: productsOptionIds })
    if (rangProductPriceChanged != 0) {
      path += "&min_price=" + productPrice.min + "&max_price=" + productPrice.max
    }

    if (productBusinessId)
      path += "&businessId=" + productBusinessId;
    if (productBrandId)
      path += "&brandId=" + productBrandId;
    if (productCategoryId)
      path += "&categoryId=" + productCategoryId;
    if (productSubcategoryId)
      path += "&subCategoryId=" + productSubcategoryId
    if (gender)
      path += "&gender=" + gender
    if (productTags)
      path += "&tags=" + productTags;


    history.push(path);
  },
    [productGenders],
  );


  const handleChangeProductCategory = useCallback((category) => {
    setProductSubcategoryId(null)
    setOfferSubcategoryId(null)
    setTwigSubcategoryId(null)


    setProductSelectedCategory(category)
    setOfferSelectedCategory(category)
    setTwigSelectedCategory(category)

    setProductSelectedSubcategory(null)
    setOfferSelectedSubcategory(null)
    setTwigSelectedSubcategory(null)
    if (category) {
      setProductCategoryId(category.id)
      setTwigCategoryId(category.id)
      setOfferCategoryId(category.id)
      setProductSubcategories(category.sub_categories)
      setOfferSubcategories(category.sub_categories)
      setTwigSubcategories(category.sub_categories)
      
    } else {
      setProductCategoryId(null)
      setTwigCategoryId(null)
      setOfferCategoryId(null)
      setProductSubcategories([])
      setOfferSubcategories([])
      setTwigSubcategories([])

    }

    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab
    // if (rangProductPriceChanged != 0) {
    //   path += "&min_price=" + productPrice.min + "&max_price=" + productPrice.max
    // }
    // if (productBusinessId)
    //   path += "&businessId=" + productBusinessId;
    // if (productBrandId)
    //   path += "&brandId=" + productBrandId;
    if (category)
      path += "&categoryId=" + category.id
    // if (productGender)
    //   path += "&gender=" + productGender
    // if (productTags)
    //   path += "&tags=" + productTags;
   
    history.push(path);

  },
    [productCategories],
  );


  const handleChangeProductBrand = useCallback((brand) => {
    setProductSelectedBrand(brand)
    setTwigSelectedBrand(brand)
    setOfferSelectedBrand(brand)
    if (brand) {
      setProductBrandId(brand.id)
    } else {
      setProductBrandId(null)
    }
    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: productsOptionIds })
    if (rangProductPriceChanged != 0) {
      path += "&min_price=" + productPrice.min + "&max_price=" + productPrice.max
    }

    if (productBusinessId)
      path += "&businessId=" + productBusinessId;

    if (brand) {
      path += "&brandId=" + brand.id
    }
    if (productCategoryId)
      path += "&categoryId=" + productCategoryId
    if (productGender)
      path += "&gender=" + productGender
    if (productTags)
      path += "&tags=" + productTags;

    history.push(path);

  },
    [productBrands],
  );


  const handleChangeProductBusiness = useCallback((business) => {
    setProductSelectedBusiness(business)
    setTwigSelectedBusiness(business)
    setOfferSelectedBusiness(business)
    if (business) {
      setProductBusinessId(business.id)
    } else {
      setProductBusinessId(null)
    }

    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: productsOptionIds })
    if (rangProductPriceChanged != 0) {
      path += "&min_price=" + productPrice.min + "&max_price=" + productPrice.max
    }
    if (business) {
      path += "&businessId=" + business.id
    }
    if (productBrandId) {
      path += "&brandId=" + productBrandId
    }
    if (productCategoryId)
      path += "&categoryId=" + productCategoryId
    if (productGender)
      path += "&gender=" + productGender
    if (productTags)
      path += "&tags=" + productTags;

    history.push(path);

  },
    [productBrands],
  );




  const handleChangeProductSubcategory = useCallback((subcategory) => {
    setProductSelectedSubcategory(subcategory)
    setOfferSelectedSubcategory(subcategory)
    setTwigSelectedSubcategory(subcategory)
    if (subcategory) {
      setProductSubcategoryId(subcategory.id)
    } else {
      setProductSubcategoryId(null)
    }
    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&categoryId=" + productCategoryId
    if (rangProductPriceChanged != 0) {
      path += "&min_price=" + productPrice.min + "&max_price=" + productPrice.max
    }

    // if (productBusinessId)
    //   path += "&businessId=" + productBusinessId;
    // if (productBrandId)
    //   path += "&brandId=" + productBrandId;
    if (subcategory)
      path += "&subCategoryId=" + subcategory.id
    // if (productGender)
    //   path += "&gender=" + productGender
    // if (productTags)
    //   path += "&tags=" + productTags;

    history.push(path);

  },
    [productSubcategories],
  );



  const handleChangeProductSearchBrand = useCallback((value) => {
    setProductSearchBrand(value)
    setTwigSearchBrand(value)
    setOfferSearchBrand(value)
  }, [productSearchBrand]);

  const handleChangeProductSearchBusiness = useCallback((value) => {
    setProductSearchBusiness(value)
    setOfferSearchBusiness(value)
    setTwigSearchBusiness(value)
  }, [productSearchBusiness]);



  useEffect(() => {
    if (selectedTab == "products")
      (async () => {
        setLoading(true)
        setDefaultActiveKey("PP")
        var tempBreadCrumb = [{ "label": "Home" }]
        setHasMoreProduct(true)

        var filterParams = "";
        if (searchKey != "" && searchKey != null) {
          filterParams = "keyword=" + searchKey + "&"
          // tempBreadCrumb.push({ "label": searchKey })
        }
        if (rangProductPriceChanged != 0) {
          filterParams += "max_price=" + productPrice.max + "&min_price=" + productPrice.min + "&"
        }
        if (productCategoryId) {
          filterParams += "category_id=" + productCategoryId + "&"

        }
        if (productBusinessId) {
          filterParams += "business_id=" + productBusinessId + "&"
        }

        if (productBrandId) {
          filterParams += "brand_id=" + productBrandId + "&"
        }
        if (productSubcategoryId) {
          filterParams += "sub_category_id=" + productSubcategoryId + "&"
        }
        if (productGender) {
          filterParams += "gender=" + productGender + "&"
          // tempBreadCrumb.push({ "label": productGender })
        }
        if (productTags) {
          let arrayProductTags = productTags.split(",");
          for (let index = 0; index < arrayProductTags.length; index++) {
            const element = arrayProductTags[index];
            filterParams += "tagnames[" + index + "]=" + element + "&";
          }
        }
        // for (const key in productsOptionSelected) {
        //   if (Object.prototype.hasOwnProperty.call(productsOptionSelected, key)) {
        //     const element = productsOptionSelected[key];
        //     if (element)
        //       filterParams += "option_values[]=" + element.id + "&"
        //   }
        // }
        productsOptionIds.forEach(element => {
          filterParams += "option_values[]=" + element + "&"
        });

        try {

          var { products: responses, pagination: paginationProduct } = await listProducts(1, 24, filterParams);
          setProducts(responses);
          var { data, data_2 } = await listOptionProducts(filterParams);
          setLoading(false)

          setProductsOption(data)
          setProductTotalCount(paginationProduct.totalCount)
          if (rangProductPriceChanged == 0) {
            setRangProductPrice({ "min": data_2.price_range.min_price, "max": data_2.price_range.max_price })
            setProductPrice({ "min": data_2.price_range.min_price, "max": data_2.price_range.max_price })
          }
          var tempCategories: any[] = [];
          data_2.categories.forEach((element: { id: any; name: any; }) => {
            tempCategories.push({ "value": element.id, "label": element.name })
          });
          setProductCategories(data_2.categories)
          setProductBrands(data_2.brands)
          setProductBusinesses(data_2.businesses)
          let tempProductsOptionSelected = []
          console.log("productsOptionIds");
          console.log(productsOptionIds);
          if (productsOptionIds.length > 0) {
            for (let index = 0; index < data.length; index++) {
              const element = data[index];
              for (let indexOption = 0; indexOption < element.option_values.length; indexOption++) {
                const elementOption = element.option_values[indexOption];
                if (productsOptionIds.indexOf(elementOption.id) != -1) {
                  tempProductsOptionSelected[element.id] = elementOption;
                }
              }
            }
          }
          setProductsOptionSelected(tempProductsOptionSelected)
          if (productBrandId) {
            let brand = data_2.brands.find((element: any) => element.id == productBrandId)
            setProductSelectedBrand(brand)
          }

          if (productBusinessId) {
            let business = data_2.businesses.find((element: any) => element.id == productBusinessId)
            setProductSelectedBusiness(business)
          }

          let tempGender = [];
          for (let index = 0; index < data_2.gender.length; index++) {
            let element = data_2.gender[index];
            element.label = element.gender == "Male" ? "Men" : element.gender == "Female" ? "Women" : ""
            tempGender.push(element)
          }
          setProductGenders(tempGender)

          let category;
          if (productCategoryId != null) {
            category = data_2.categories.find((element: any) => element.id == productCategoryId)
            setProductSelectedCategory(category)
            tempBreadCrumb.push({ "label": category.name })

            let tempProductSubCategory = category.sub_categories
            setProductSubcategories(tempProductSubCategory)
          }
          if (productSubcategoryId) {
            let subcategory = category.sub_categories.find((element: any) => element.id == productSubcategoryId)
            if (subcategory) {
              setProductSelectedSubcategory(subcategory)
              tempBreadCrumb.push({ "label": subcategory.name })
            }
          }
          if (responses.length < 10) {
            setHasMoreProduct(false);
          } else {
            setHasMoreProduct(true);
            setCurrentPageProduct(2);
          }
          setDoInfiniteScrollProduct(true);
          if (tempBreadCrumb.length == 1) {
            tempBreadCrumb.push({ "label": "Search" })
          }
          setBreadCrumb(tempBreadCrumb)
        } catch (e) {
          console.error(e);
        }
      })()
  }, [searchKey, selectedTab, productsOptionIds, rangProductPriceChanged, productCategoryId, productBrandId, productBusinessId, productGender, productSubcategoryId, productTags]
  )



  // offers

  const deleteOffersOption = useCallback(
    (optionId) => {

      let tempOffersOptionIds = offersOptionIds.slice(0);
      if (tempOffersOptionIds.indexOf(optionId) != -1) {
        tempOffersOptionIds.splice(tempOffersOptionIds.indexOf(optionId), 1)
      }
      let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: tempOffersOptionIds });  //option=" + JSON.stringify(tempProductsOptionSelected)

      setOffersOptionIds(tempOffersOptionIds)
      setProductsOptionIds(tempOffersOptionIds)
      setTwigsOptionIds(tempOffersOptionIds)
      if (rangOfferPriceChanged != 0) {
        path += "&min_price=" + offerPrice.min + "&max_price=" + offerPrice.max
      }

      if (offerBusinessId)
        path += "&businessId=" + offerBusinessId;
      if (offerBrandId)
        path += "&brandId=" + offerBrandId;
      if (offerCategoryId)
        path += "&categoryId=" + offerCategoryId;
      if (offerSubcategoryId)
        path += "&subCategoryId=" + offerSubcategoryId
      if (offerGender)
        path += "&gender=" + offerGender;
      if (offerTags)
        path += "&tags=" + offerTags;

      history.push(path);


    },
    [offersOptionIds],
  );


  const deleteOffersPrice = useCallback(() => {
    setRangOfferPriceChanged(0)
    setRangTwigPriceChanged(0)
    setRangTwigPriceChanged(0)
    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: offersOptionIds });

    if (offerBusinessId)
      path += "&businessId=" + offerBusinessId;
    if (offerBrandId)
      path += "&brandId=" + offerBrandId;
    if (offerCategoryId)
      path += "&categoryId=" + offerCategoryId;
    if (offerSubcategoryId)
      path += "&subCategoryId=" + offerSubcategoryId
    if (offerGender)
      path += "&gender=" + productGender
    if (offerTags)
      path += "&tags=" + offerTags;

    history.push(path);
  },
    [offerPrice],
  )

  const handelChangeOffersPrice = useCallback((value: any) => {
    setRangOfferPriceChanged(rangOfferPriceChanged + 1)
    setRangProductPriceChanged(rangOfferPriceChanged + 1)
    setRangTwigPriceChanged(rangOfferPriceChanged + 1)
    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&min_price=" + value.min + "&max_price=" + value.max + "&" + queryString.stringify({ option: offersOptionIds });

    if (offerBusinessId)
      path += "&businessId=" + offerBusinessId;
    if (offerBrandId)
      path += "&brandId=" + offerBrandId;
    if (offerCategoryId)
      path += "&categoryId=" + offerCategoryId;
    if (offerSubcategoryId)
      path += "&subCategoryId=" + offerSubcategoryId
    if (offerGender)
      path += "&gender=" + productGender
    if (offerTags)
      path += "&tags=" + offerTags;

    history.push(path);
  },
    [offerPrice],
  )


  const handleChangeOfferFilter = useCallback((x: number, y: any) => {
    let tempOffersOptionIds = offersOptionIds.slice(0);
    if (y != null) {
      tempOffersOptionIds.push(y.id);
      if (offersOptionSelected[x]) {
        tempOffersOptionIds.splice(tempOffersOptionIds.indexOf(offersOptionSelected[x].id), 1)
      }
    } else if (y == null || tempOffersOptionIds.indexOf(y) != -1) {
      tempOffersOptionIds.splice(tempOffersOptionIds.indexOf(y), 1)
    }
    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: tempOffersOptionIds });  //option=" + JSON.stringify(tempProductsOptionSelected)

    if (rangOfferPriceChanged != 0) {
      path += "&min_price=" + offerPrice.min + "&max_price=" + offerPrice.max
    }

    if (offerBusinessId)
      path += "&businessId=" + offerBusinessId;
    if (offerBrandId)
      path += "&brandId=" + offerBrandId;
    if (offerCategoryId)
      path += "&categoryId=" + offerCategoryId;
    if (offerSubcategoryId)
      path += "&subCategoryId=" + offerSubcategoryId
    if (offerGender)
      path += "&gender=" + offerGender
    if (offerTags)
      path += "&tags=" + offerTags;

    setOffersOptionIds(tempOffersOptionIds)
    setProductsOptionIds(tempOffersOptionIds)
    setTwigsOptionIds(tempOffersOptionIds)
    history.push(path);

  },
    [offersOptionSelected, offersOptionIds],
  );


  const handleChangeOfferGender = useCallback((gender) => {
    setOfferGender(gender)
    setTwigGender(gender)
    setProductGender(gender)

    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: offersOptionIds });
    if (rangOfferPriceChanged != 0) {
      path += "&min_price=" + offerPrice.min + "&max_price=" + offerPrice.max
    }

    if (offerBusinessId)
      path += "&businessId=" + offerBusinessId;
    if (offerBrandId)
      path += "&brandId=" + offerBrandId;
    if (offerCategoryId)
      path += "&categoryId=" + offerCategoryId;
    if (offerSubcategoryId)
      path += "&subCategoryId=" + offerSubcategoryId
    if (gender)
      path += "&gender=" + gender
    if (offerTags)
      path += "&tags=" + offerTags;

    history.push(path);
  },
    [offerGenders],
  );


  const handleChangeOfferCategory = useCallback((category) => {
    setOfferSubcategoryId(null)
    setProductSubcategoryId(null)
    setTwigSubcategoryId(null)


    setOfferSelectedCategory(category)
    setProductSelectedCategory(category)
    setTwigSelectedCategory(category)

    setOfferSelectedSubcategory(null)
    setTwigSelectedSubcategory(null)
    setProductSelectedSubcategory(null)
    if (category) {
      setProductCategoryId(category.id)
      setTwigCategoryId(category.id)
      setOfferCategoryId(category.id)
      setProductSubcategories(category.sub_categories)
      setOfferSubcategories(category.sub_categories)
      setTwigSubcategories(category.sub_categories)
    } else {
      setProductCategoryId(null)
      setTwigCategoryId(null)
      setOfferCategoryId(null)
      setProductSubcategories([])
      setOfferSubcategories([])
      setTwigSubcategories([])
    }

    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab
    // if (rangOfferPriceChanged != 0) {
    //   path += "&min_price=" + offerPrice.min + "&max_price=" + offerPrice.max
    // }

    // if (offerBusinessId)
    //   path += "&businessId=" + offerBusinessId;
    // if (offerBrandId)
    //   path += "&brandId=" + offerBrandId;
    if (category)
      path += "&categoryId=" + category.id
    // if (offerGender)
    //   path += "&gender=" + offerGender
    // if (offerTags)
    //   path += "&tags=" + offerTags;

    history.push(path);

  },
    [offerCategories],
  );


  const handleChangeOfferBrand = useCallback((brand) => {
    setOfferSelectedBrand(brand)
    setTwigSelectedBrand(brand)
    setProductSelectedBrand(brand)
    if (brand) {
      setOfferBrandId(brand.id)
    } else {
      setOfferBrandId(null)
    }

    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: offersOptionIds });
    if (rangOfferPriceChanged != 0) {
      path += "&min_price=" + offerPrice.min + "&max_price=" + offerPrice.max
    }

    if (brand) {
      path += "&brandId=" + brand.id
    }
    if (offerBusinessId)
      path += "&businessId=" + offerBusinessId;
    if (offerCategoryId)
      path += "&categoryId=" + offerCategoryId
    if (offerGender)
      path += "&gender=" + offerGender
    if (offerTags)
      path += "&tags=" + offerTags;

    history.push(path);

  },
    [offerBrands],
  );


  const handleChangeOfferBusiness = useCallback((business) => {
    setOfferSelectedBusiness(business)
    setTwigSelectedBusiness(business)
    setProductSelectedBusiness(business)
    if (business) {
      setOfferBusinessId(business.id)
    } else {
      setOfferBusinessId(null)
    }

    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: offersOptionIds });
    if (rangOfferPriceChanged != 0) {
      path += "&min_price=" + offerPrice.min + "&max_price=" + offerPrice.max
    }

    if (offerBrandId) {
      path += "&brandId=" + offerBrandId
    }
    if (business)
      path += "&businessId=" + business.id;
    if (offerCategoryId)
      path += "&categoryId=" + offerCategoryId
    if (offerGender)
      path += "&gender=" + offerGender
    if (offerTags)
      path += "&tags=" + offerTags;

    history.push(path);

  },
    [offerBusinesses],
  );



  const handleChangeOfferTag = useCallback((tag) => {
    let newTags = offerTags.split(",");
    newTags.splice(newTags.indexOf(tag), 1);
    let newTagsString: string = newTags.join();
    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: offersOptionIds });
    if (rangOfferPriceChanged != 0) {
      path += "&min_price=" + offerPrice.min + "&max_price=" + offerPrice.max
    }

    if (offerBusinessId)
      path += "&businessId=" + offerBusinessId;
    if (offerBrandId)
      path += "&brandId=" + offerBrandId;
    if (offerCategoryId)
      path += "&categoryId=" + offerCategoryId;
    if (offerSubcategoryId)
      path += "&subCategoryId=" + offerSubcategoryId
    if (offerGender)
      path += "&gender=" + offerGender
    if (newTagsString)
      path += "&tags=" + newTagsString


    setOfferTags(newTagsString)
    setTwigTags(newTagsString)
    setProductTags(newTagsString)
    history.push(path);
  },
    [offerTags],
  );



  const handleChangeOfferSubcategory = useCallback((subcategory) => {
    setOfferSelectedSubcategory(subcategory)
    setTwigSelectedSubcategory(subcategory)
    setProductSelectedSubcategory(subcategory)
    if (subcategory) {
      setOfferSubcategoryId(subcategory.id)
    } else {
      setOfferSubcategoryId(null)
    }
    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&categoryId=" + offerCategoryId
    // if (rangOfferPriceChanged != 0) {
    //   path += "&min_price=" + offerPrice.min + "&max_price=" + offerPrice.max
    // }

    // if (offerBusinessId)
    //   path += "&businessId=" + offerBusinessId;
    // if (offerBrandId)
    //   path += "&brandId=" + offerBrandId;
    if (subcategory)
      path += "&subCategoryId=" + subcategory.id
    // if (offerGender)
    //   path += "&gender=" + offerGender
    // if (offerTags)
    //   path += "&tags=" + offerTags;

    history.push(path);

  },
    [offerSubcategories],
  );



  const handleChangeOfferSearchBrand = useCallback((value) => {
    setOfferSearchBrand(value)
    setTwigSearchBrand(value)
    setProductSearchBrand(value)
  }, [productSearchBrand]);

  const handleChangeOfferSearchBusiness = useCallback((value) => {
    setOfferSearchBusiness(value)
    setProductSearchBusiness(value)
    setTwigSearchBusiness(value)
  }, [productSearchBusiness]);



  useEffect(() => {
    if (selectedTab == "offers")
      (async () => {
        setDefaultActiveKey("PO")
        setLoading(true)

        var tempBreadCrumb = [{ "label": "Home" }]
        setHasMoreOffer(true)
        var filterParams = "";
        if (searchKey != "" && searchKey != null) {
          filterParams = "keyword=" + searchKey + "&"
          // tempBreadCrumb.push({ "label": searchKey })
        }

        if (rangOfferPriceChanged != 0) {
          filterParams += "max_price=" + offerPrice.max + "&min_price=" + offerPrice.min + "&"
        }
        if (offerBusinessId)
          filterParams += "business_id=" + offerBusinessId + "&"
        if (offerCategoryId)
          filterParams += "category_id=" + offerCategoryId + "&"
        if (offerBrandId)
          filterParams += "brand_id=" + offerBrandId + "&"
        if (offerSubcategoryId)
          filterParams += "sub_category_id=" + offerSubcategoryId + "&"
        if (offerGender) {
          filterParams += "gender=" + offerGender + "&"
          // tempBreadCrumb.push({ "label": offerGender })
        }

        if (offerTags) {
          let arrayTwigTags = offerTags.split(",");
          for (let index = 0; index < arrayTwigTags.length; index++) {
            const element = arrayTwigTags[index];
            filterParams += "tagnames[" + index + "]=" + element + "&";
          }
        }

        offersOptionIds.forEach(element => {
          filterParams += "option_values[]=" + element + "&"
        });


        
        if (filterParams.length != 1)
          filterParams += "&"
        try {
         //my

          var { products: responses, pagination: paginationOffer } = await listProducts(1, 24, filterParams, true);
          var { data, data_2 } = await listOptionProducts(filterParams, true);
          setOffersOption(data)
          setOffers(responses);
          setOfferTotalCount(paginationOffer.totalCount)
          if (rangOfferPriceChanged == 0) {
            setRangOfferPrice({ "min": data_2.price_range.min_price, "max": data_2.price_range.max_price })
            setOfferPrice({ "min": data_2.price_range.min_price, "max": data_2.price_range.max_price })
          }

          let tempOffersOptionSelected = []

          if (offersOptionIds.length > 0) {
            for (let index = 0; index < data.length; index++) {
              const element = data[index];
              for (let indexOption = 0; indexOption < element.option_values.length; indexOption++) {
                const elementOption = element.option_values[indexOption];
                if (offersOptionIds.indexOf(elementOption.id) != -1) {
                  tempOffersOptionSelected[element.id] = elementOption;
                }
              }
            }
          }
          setOffersOptionSelected(tempOffersOptionSelected)
          setOfferCategories(data_2.categories)
          setOfferBrands(data_2.brands)
          setOfferBusinesses(data_2.businesses)


          if (offerBusinessId) {
            let business = data_2.businesses.find((element: any) => element.id == offerBusinessId)
            setOfferSelectedBusiness(business)
          }



          if (offerBrandId) {
            let brand = data_2.brands.find((element: any) => element.id == offerBrandId)
            setOfferSelectedBrand(brand)
            // tempBreadCrumb.push({ "label": brand.name })

          }
          // setOfferGenders(data_2.gender)
          let tempGender = [];
          for (let index = 0; index < data_2.gender.length; index++) {
            let element = data_2.gender[index];
            element.label = element.gender == "Male" ? "Men" : element.gender == "Female" ? "Women" : ""
            tempGender.push(element)
          }
          setOfferGenders(tempGender)

          let category;
          if (offerCategoryId != null) {
            category = data_2.categories.find((element: any) => element.id == offerCategoryId)
            setOfferSelectedCategory(category)
            let tempOfferSubCategory = category.sub_categories
            setOfferSubcategories(tempOfferSubCategory)
            tempBreadCrumb.push({ "label": category.name })

          }
          if (offerSubcategoryId) {
            let subcategory = category.sub_categories.find((element: any) => element.id == offerSubcategoryId)
            setOfferSelectedSubcategory(subcategory)
            tempBreadCrumb.push({ "label": subcategory.name })

          }
          if (responses.length > 10) {
            setHasMoreOffer(false);
          } else {
            setCurrentPageOffer(2);
            setHasMoreOffer(true);
          }
          setDoInfiniteScrollOffer(true);
          if (tempBreadCrumb.length == 1) {
            tempBreadCrumb.push({ "label": "Search" })
          }
          setBreadCrumb(tempBreadCrumb)
          setLoading(false)

        } catch (e) {
          console.error(e);
        }
      })()
  }, [searchKey, selectedTab, offersOptionIds, rangOfferPriceChanged, offerCategoryId, offerBusinessId, offerBrandId, offerGender, offerSubcategoryId]
  )


  // twigs



  const deleteTwigsOption = useCallback(
    (optionId) => {
      let tempTwigsOptionIds = twigsOptionIds.slice(0);
      if (tempTwigsOptionIds.indexOf(optionId) != -1) {
        tempTwigsOptionIds.splice(tempTwigsOptionIds.indexOf(optionId), 1)
      }

      let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: tempTwigsOptionIds });  //option=" + JSON.stringify(tempProductsOptionSelected)

      setTwigsOptionIds(tempTwigsOptionIds)
      setOffersOptionIds(tempTwigsOptionIds)
      setProductsOptionIds(tempTwigsOptionIds)

      if (twigBrandId)
        path += "&brandId=" + twigBrandId;
      if (twigBusinessId)
        path += "&businessId=" + twigBusinessId;
      if (twigCategoryId)
        path += "&categoryId=" + twigCategoryId;
      if (twigSubcategoryId)
        path += "&subCategoryId=" + twigSubcategoryId
      if (twigGender)
        path += "&gender=" + twigGender
      if (twigTags)
        path += "&tags=" + twigTags
      history.push(path);


    },
    [twigsOptionIds],
  );


  const handelChangeTwigsPrice = useCallback((value: any) => {
    setRangTwigPriceChanged(rangTwigPriceChanged + 1)
    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&min_price=" + value.min + "&max_price=" + value.max + "&" + queryString.stringify({ option: twigsOptionIds })

    if (twigBrandId)
      path += "&brandId=" + twigBrandId;
    if (twigBusinessId)
      path += "&businessId=" + twigBusinessId;
    if (twigCategoryId)
      path += "&categoryId=" + twigCategoryId;
    if (twigSubcategoryId)
      path += "&subCategoryId=" + twigSubcategoryId
    if (twigGender)
      path += "&gender=" + twigGender
    if (twigTags)
      path += "&tags=" + twigTags


  },
    [twigPrice],
  )

  const deleteTwigsPrice = useCallback(() => {
    setRangTwigPriceChanged(0)
    setRangOfferPriceChanged(0)
    setRangProductPriceChanged(0)
    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: twigsOptionIds })

    if (twigBrandId)
      path += "&brandId=" + twigBrandId;
    if (twigBusinessId)
      path += "&businessId=" + twigBusinessId;
    if (twigCategoryId)
      path += "&categoryId=" + twigCategoryId;
    if (twigSubcategoryId)
      path += "&subCategoryId=" + twigSubcategoryId
    if (twigGender)
      path += "&gender=" + twigGender
    if (twigTags)
      path += "&tags=" + twigTags


  },
    [twigPrice],
  )

  const handleChangeTwigFilter = useCallback((x: number, y: any) => {
    let tempTwigsOptionIds = twigsOptionIds.slice(0);
    if (y != null) {
      tempTwigsOptionIds.push(y.id);
      if (twigsOptionSelected[x]) {
        tempTwigsOptionIds.splice(tempTwigsOptionIds.indexOf(twigsOptionSelected[x].id), 1)
      }
    } else if (y == null || tempTwigsOptionIds.indexOf(y) != -1) {
      tempTwigsOptionIds.splice(tempTwigsOptionIds.indexOf(y), 1)
    }
    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: tempTwigsOptionIds });  //option=" + JSON.stringify(tempProductsOptionSelected)


    if (rangTwigPriceChanged != 0) {
      path += "&min_price=" + twigPrice.min + "&max_price=" + twigPrice.max
    }

    if (twigBusinessId)
      path += "&businessId=" + twigBusinessId;
    if (twigBrandId)
      path += "&brandId=" + twigBrandId;
    if (twigCategoryId)
      path += "&categoryId=" + twigCategoryId;
    if (twigSubcategoryId)
      path += "&subCategoryId=" + twigSubcategoryId
    if (twigGender)
      path += "&gender=" + twigGender
    if (twigTags)
      path += "&tags=" + twigTags


    setTwigsOptionIds(tempTwigsOptionIds)
    setOffersOptionIds(tempTwigsOptionIds)
    setProductsOptionIds(tempTwigsOptionIds)
    history.push(path);

  },
    [twigsOptionIds, twigsOptionSelected],
  );

  const handleChangeTwigTag = useCallback((tag) => {
    let newTags = twigTags.split(",");
    newTags.splice(newTags.indexOf(tag), 1);
    let newTagsString: string = newTags.join();
    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: twigsOptionIds })
    if (rangTwigPriceChanged != 0) {
      path += "&min_price=" + twigPrice.min + "&max_price=" + twigPrice.max
    }

    if (twigBusinessId)
      path += "&businessId=" + twigBusinessId;
    if (twigBrandId)
      path += "&brandId=" + twigBrandId;
    if (twigCategoryId)
      path += "&categoryId=" + twigCategoryId;
    if (twigSubcategoryId)
      path += "&subCategoryId=" + twigSubcategoryId
    if (twigGender)
      path += "&gender=" + twigGender
    if (newTagsString)
      path += "&tags=" + newTagsString

    setTwigTags(newTagsString)
    setOfferTags(newTagsString)
    setProductTags(newTagsString)
    history.push(path);
  },
    [twigTags],
  );



  const handleChangeTwigGender = useCallback((gender) => {
    setTwigGender(gender)
    setOfferGender(gender)
    setProductGender(gender)

    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: twigsOptionIds })
    if (rangTwigPriceChanged != 0) {
      path += "&min_price=" + twigPrice.min + "&max_price=" + twigPrice.max
    }

    if (twigBusinessId)
      path += "&businessId=" + twigBusinessId;
    if (twigBrandId)
      path += "&brandId=" + twigBrandId;
    if (twigCategoryId)
      path += "&categoryId=" + twigCategoryId;
    if (twigSubcategoryId)
      path += "&subCategoryId=" + twigSubcategoryId
    if (gender)
      path += "&gender=" + gender
    if (twigTags)
      path += "&tags=" + twigTags

    history.push(path);
  },
    [twigGenders],
  );


  const handleChangeTwigCategory = useCallback((category) => {
    setTwigSubcategoryId(null)
    setProductSubcategoryId(null)
    setOfferSubcategoryId(null)
    setTwigSelectedCategory(category)
    setProductSelectedCategory(category)
    setOfferSelectedCategory(category)
    setTwigSelectedSubcategory(null)
    setOfferSelectedSubcategory(null)
    setProductSelectedSubcategory(null)
    if (category) {
      setProductCategoryId(category.id)
      setTwigCategoryId(category.id)
      setOfferCategoryId(category.id)
      setProductSubcategories(category.sub_categories)
      setOfferSubcategories(category.sub_categories)
      setTwigSubcategories(category.sub_categories)
    } else {
      setProductCategoryId(null)
      setTwigCategoryId(null)
      setOfferCategoryId(null)
      setProductSubcategories([])
      setOfferSubcategories([])
      setTwigSubcategories([])
    }

    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab
    if (rangTwigPriceChanged != 0) {
      path += "&min_price=" + twigPrice.min + "&max_price=" + twigPrice.max
    }

    // if (twigBusinessId)
    //   path += "&businessId=" + twigBusinessId;
    // if (twigBrandId)
    //   path += "&brandId=" + twigBrandId;
    if (category)
      path += "&categoryId=" + category.id
    // if (twigGender)
    //   path += "&gender=" + twigGender
    // if (twigTags)
    //   path += "&tags=" + twigTags

    history.push(path);

  },
    [twigCategories],
  );


  const handleChangeTwigBrand = useCallback((brand) => {
    setTwigSelectedBrand(brand)
    setProductSelectedBrand(brand)
    setOfferSelectedBrand(brand)
    if (brand) {
      setTwigBrandId(brand.id)
    } else {
      setTwigBrandId(null)
    }

    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: twigsOptionIds })
    if (rangTwigPriceChanged != 0) {
      path += "&min_price=" + twigPrice.min + "&max_price=" + twigPrice.max
    }

    if (brand) {
      path += "&brandId=" + brand.id
    }
    if (twigBusinessId)
      path += "&businessId=" + twigBusinessId;
    if (twigCategoryId)
      path += "&categoryId=" + twigCategoryId
    if (twigGender)
      path += "&gender=" + twigGender
    if (twigTags)
      path += "&tags=" + twigTags

    history.push(path);

  },
    [twigBrands],
  );


  const handleChangeTwigBusiness = useCallback((business) => {
    setTwigSelectedBusiness(business)
    setOfferSelectedBusiness(business)
    setProductSelectedBusiness(business)
    if (business) {
      setTwigBusinessId(business.id)
    } else {
      setTwigBusinessId(null)
    }

    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&" + queryString.stringify({ option: twigsOptionIds })
    if (rangTwigPriceChanged != 0) {
      path += "&min_price=" + twigPrice.min + "&max_price=" + twigPrice.max
    }

    if (twigBrandId) {
      path += "&brandId=" + twigBrandId
    }
    if (business)
      path += "&businessId=" + business.id;
    if (twigCategoryId)
      path += "&categoryId=" + twigCategoryId
    if (twigGender)
      path += "&gender=" + twigGender
    if (twigTags)
      path += "&tags=" + twigTags

    history.push(path);

  },
    [twigBrands],
  );




  const handleChangeTwigSubcategory = useCallback((subcategory) => {
    setTwigSelectedSubcategory(subcategory)
    setOfferSelectedSubcategory(subcategory)
    setProductSelectedSubcategory(subcategory)
    if (subcategory) {
      setTwigSubcategoryId(subcategory.id)
    } else {
      setTwigSubcategoryId(null)
    }
    let path = "/search?searchKey=" + searchKey + "&tab=" + selectedTab + "&categoryId=" + productCategoryId
    if (rangTwigPriceChanged != 0) {
      path += "&min_price=" + twigPrice.min + "&max_price=" + twigPrice.max
    }

    // if (twigBusinessId)
    //   path += "&businessId=" + twigBusinessId;
    // if (twigBrandId)
    //   path += "&brandId=" + twigBrandId;
    if (subcategory)
      path += "&subCategoryId=" + subcategory.id
    // if (twigGender)
    //   path += "&gender=" + twigGender
    // if (twigTags)
    //   path += "&tags=" + twigTags

    history.push(path);

  },
    [twigSubcategories],
  );



  const handleChangeTwigSearchBrand = useCallback((value) => {
    setTwigSearchBrand(value)
    setOfferSearchBrand(value)
    setProductSearchBrand(value)
  }, [twigSearchBrand]);

  const handleChangeTwigSearchBusiness = useCallback((value) => {
    setTwigSearchBusiness(value)
    setProductSearchBusiness(value)
    setOfferSearchBusiness(value)
  }, [twigSearchBrand]);


  useEffect(() => {
    if (selectedTab == "twigs")
      (async () => {
        setLoading(true)

        setDefaultActiveKey("PT")
        setHasMoreProduct(true)
        var tempBreadCrumb = [{ "label": "Home" }]

        var filterParams = ""
        if (searchKey != "" && searchKey != null) {
          filterParams = "keyword=" + searchKey + "&"
          // tempBreadCrumb.push({ "label": searchKey })
        }

        if (rangTwigPriceChanged != 0) {
          filterParams += "max_price=" + twigPrice.max + "&min_price=" + twigPrice.min + "&"
        }
        if (twigCategoryId)
          filterParams += "category_id=" + twigCategoryId + "&"
        if (twigBusinessId)
          filterParams += "business_id=" + twigBusinessId + "&"
        if (twigBrandId)
          filterParams += "brand_id=" + twigBrandId + "&"
        if (twigSubcategoryId)
          filterParams += "sub_category_id=" + twigSubcategoryId + "&"
        if (twigGender) {
          filterParams += "gender=" + twigGender + "&"
          // tempBreadCrumb.push({ "label": offerGender })
        }
        if (twigTags) {
          let arrayTwigTags = twigTags.split(",");
          for (let index = 0; index < arrayTwigTags.length; index++) {
            const element = arrayTwigTags[index];
            filterParams += "tagnames[" + index + "]=" + element + "&";
          }
        }

        twigsOptionIds.forEach(element => {
          filterParams += "option_values[]=" + element + "&"
        });
        // if (filterParams.length != 1)
        //   filterParams += "&"
        try {

          var { data, data_2 } = await listOptionTwigs(filterParams);

          setTwigsOption(data)
         //my
          var { twigs: response, pagination: paginationTwig } = await listTwigs(1, 24, filterParams);
          setTwigs(response);
          setTwigTotalCount(paginationTwig.totalCount)
          if (rangTwigPriceChanged == 0) {
            setRangTwigPrice({ "min": data_2.price_range.min_price, "max": data_2.price_range.max_price })
            setTwigPrice({ "min": data_2.price_range.min_price, "max": data_2.price_range.max_price })
          }
          setTwigCategories(data_2.categories)
          setTwigBrands(data_2.brands)

          if (twigBrandId) {
            let brand = data_2.brands.find((element: any) => element.id == twigBrandId)
            setTwigSelectedBrand(brand)
            // tempBreadCrumb.push({ "label": brand.name })

          }

          setTwigBusinesses(data_2.businesses)

          let tempTwigsOptionSelected = []

          if (twigsOptionIds.length > 0) {
            for (let index = 0; index < data.length; index++) {
              const element = data[index];
              for (let indexOption = 0; indexOption < element.option_values.length; indexOption++) {
                const elementOption = element.option_values[indexOption];
                if (productsOptionIds.indexOf(elementOption.id) != -1) {
                  tempTwigsOptionSelected[element.id] = elementOption;
                }
              }
            }
          }
          setTwigsOptionSelected(tempTwigsOptionSelected)
          if (twigBusinessId) {
            let business = data_2.businesses.find((element: any) => element.id == twigBusinessId)
            setTwigSelectedBusiness(business)
          }
          // setTwigGenders(data_2.gender)
          let tempGender = [];
          for (let index = 0; index < data_2.gender.length; index++) {
            let element = data_2.gender[index];
            element.label = element.gender == "Male" ? "Men" : element.gender == "Female" ? "Women" : ""
            tempGender.push(element)
          }
          setTwigGenders(tempGender)

          let category;
          if (twigCategoryId != null) {
            category = data_2.categories.find((element: any) => element.id == twigCategoryId)
            setTwigSelectedCategory(category)
            let tempTwigSubCategory = category.sub_categories
            setTwigSubcategories(tempTwigSubCategory)
            tempBreadCrumb.push({ "label": category.name })
          }
          if (twigSubcategoryId) {
            let subcategory = category.sub_categories.find((element: any) => element.id == twigSubcategoryId)
            setTwigSelectedSubcategory(subcategory)
            tempBreadCrumb.push({ "label": subcategory.name })
          }

          if (response.length < 10) {
            setHasMore(false);
          } else {
            setHasMore(true);
            setCurrentPage(2);
          }
          setDoInfiniteScroll(true);
          if (tempBreadCrumb.length == 1) {
            tempBreadCrumb.push({ "label": "Search" })
          }
          setBreadCrumb(tempBreadCrumb)
          setLoading(false)

        } catch (e) {
          console.error(e);
        }
      })()
  }, [searchKey, twigsOptionIds, selectedTab, rangTwigPriceChanged, twigBusinessId, twigCategoryId, twigBrandId, twigGender, twigSubcategoryId, twigTags]
  )

  // useEffect(() => {
  //   (async () => {
  //     setLoading(true);
  //     try {
  //       var filterParams = "&";
  //       for (const key in productsOptionSelected) {
  //         if (Object.prototype.hasOwnProperty.call(productsOptionSelected, key)) {
  //           const element = productsOptionSelected[key];
  //           filterParams += "option_values[]=" + element.id + "&"
  //         }
  //       }
  //       if (filterParams.length != 1)
  //         filterParams += "&"
  //       var { twigs: response, pagination } = await listTwigs(1, 10, "keyword=" + searchKey + filterParams + "&latitude=25.2&longitude=55.27");
  //       setTwigs(response);

  //       if (currentPage >= pagination.totalPages) {
  //         setHasMore(false);
  //       } else {
  //         setCurrentPage(currentPage + 1);
  //       }
  //       setDoInfiniteScroll(true);
  //       var { data } = await listOptionProducts("keyword=" + searchKey);
  //       setProductsOption(data)
  //       var { products: responses, pagination: paginationProduct } = await listProducts(1, 10, "keyword=" + searchKey);
  //       setProducts(responses);


  //       if (currentPageProduct >= paginationProduct.totalPages) {
  //         setHasMoreProduct(false);
  //       } else {
  //         setCurrentPageProduct(currentPageProduct + 1);
  //       }
  //       setDoInfiniteScrollProduct(true);

  //     } catch (e) {
  //       console.error(e);
  //     }
  //     setLoading(false);
  //   })();
  // }, []);


  return (
    <>
      <DefaultLayout breadCrumb={breadCrumb} history={history}>
        <Helmet>
          <title>Search page | twigBIG | Social eCommerce Marketplace in Beauty and Fashion</title>
        </Helmet>


        <Container fluid className={classes.container}>
          <Loader center className={classes.loader} loading={loading}>
            {() => (
              <>
                <Row>
                  <Col xs={12} className={classes.oneTabNav}>
                    <div className={classes.oneTabNavTag}>
                      All
                    </div>
                  </Col>
                </Row>
                {/* <Col md={2} xs={12}> */}
                <div className={classes.rowSeach}>
                  <div className={clsx(classes.filterCol, viewFilter ? classes.viewFilterCol : "")}>
                    <div className={clsx(classes.filterHeader)}>

                      <Text as="h3" bold> Filter By</Text>

                      {/* <div className={classes.spreaterFilter}></div> */}
                    </div>
                    <div className={
                      clsx(classes.filterDev, viewFilter ? classes.viewFilter : "")}>

                      <div className={clsx(classes.mobileFilterHeader, viewFilter ? classes.viewMobileFilterHeader : "")}>

                        <Text as="h3" bold> Filter By</Text>
                        <AiOutlineClose onClick={() => setViewFilter(false)}
                          className={classes.closeFilter}></AiOutlineClose>
                        {/* <div className={classes.spreaterFilter}></div> */}
                      </div>
                      {
                        selectedTab == "products" ?
                          <>
                            <div className={classes.property}>
                              {/* <Text as="span" className={classes.textProperty} bold>Category</Text> */}
                              <Accordion className={classes.accordion} defaultActiveKey="PC" >

                                <Accordion.Toggle eventKey="PC">

                                  <Text as="span" className={classes.textProperty} bold>Category</Text>
                                  <FiChevronRight></FiChevronRight>

                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey="PC">
                                  <>
                                    <label className="radio">
                                      <input type="radio" name="category" onChange={e => handleChangeProductCategory(null)} checked={productCategoryId == null} value=""></input>
                                      <Text as="span" className={classes.titleProperty}>
                                        All
                                      </Text>
                                    </label>

                                    {
                                      productCategories.map((category) =>
                                        <>
                                          <label className="radio" key={category.id}>
                                            <input type="radio" name="category" onChange={e => handleChangeProductCategory(category)} checked={productCategoryId == category.id} ></input>
                                            <Text as="span" className={classes.titleProperty}>{category.name}
                                            </Text>
                                          </label>
                                        </>
                                      )
                                    }
                                  </>

                                </Accordion.Collapse>
                              </Accordion>
                            </div>



                            {
                              productSubcategories.length != 0 ?
                                <>
                                  <div className={classes.property}>
                                    <Accordion className={classes.accordion} defaultActiveKey="PS">

                                      <Accordion.Toggle eventKey="PS">
                                        <Text as="span" className={classes.textProperty} bold>Sub Category</Text>
                                        <FiChevronRight></FiChevronRight>

                                      </Accordion.Toggle>
                                      <Accordion.Collapse eventKey="PS">
                                        <>

                                          <label className="radio">
                                            <input type="radio" name="subcategory" onChange={e => handleChangeProductSubcategory(null)} checked={productSubcategoryId == null} value=""></input>
                                            <Text as="span" className={classes.titleProperty}>All</Text>
                                          </label>
                                          {
                                            productSubcategories.map((subcategory) =>
                                              <>
                                                <label className="radio" key={subcategory.id}>
                                                  <input type="radio" name="subcategory" checked={productSubcategoryId == subcategory.id} onChange={e => handleChangeProductSubcategory(subcategory)} ></input>
                                                  <Text as="span" className={classes.titleProperty}>{subcategory.name}
                                                    <Text as="span" fontSize="size1" className={classes.titleCountProperty}>({subcategory.products_count})</Text>

                                                  </Text>
                                                </label>
                                              </>
                                            )
                                          }
                                        </>
                                      </Accordion.Collapse>
                                    </Accordion>
                                  </div>
                                </>
                                : null
                            }
                          </>
                          :
                          selectedTab == 'twigs' ?
                            <>
                              <div className={classes.property}>
                                <Accordion className={classes.accordion} defaultActiveKey="TC">

                                  <Accordion.Toggle eventKey="TC">
                                    <Text as="span" className={classes.textProperty} bold>Category</Text>
                                    <FiChevronRight></FiChevronRight>

                                  </Accordion.Toggle>
                                  <Accordion.Collapse eventKey="TC">
                                    <>
                                      <label className="radio">
                                        <input type="radio" name="category" onChange={e => handleChangeTwigCategory(null)} checked={twigCategoryId == null} value=""></input>
                                        <Text as="span" className={classes.titleProperty}>All
                                        </Text>
                                      </label>

                                      {
                                        twigCategories.map((category) =>
                                          <>
                                            <label className="radio" key={category.id}>
                                              <input type="radio" name="category" onChange={e => handleChangeTwigCategory(category)} checked={twigCategoryId == category.id} ></input>
                                              <Text as="span" className={classes.titleProperty}>{category.name}
                                              </Text>
                                            </label>
                                          </>
                                        )
                                      }
                                    </>
                                  </Accordion.Collapse>
                                </Accordion>
                              </div>




                              {
                                twigSubcategories.length != 0 ?
                                  <>
                                    <div className={classes.property}>
                                      <Accordion className={classes.accordion} defaultActiveKey="TS">
                                        <Accordion.Toggle eventKey="TS">
                                          <Text as="span" className={classes.textProperty} bold>Sub Category</Text>
                                          <FiChevronRight></FiChevronRight>

                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="TS">
                                          <>

                                            <label className="radio">
                                              <input type="radio" name="subcategory" onChange={e => handleChangeTwigSubcategory(null)} checked={twigSubcategoryId == null} value=""></input>
                                              <Text as="span" className={classes.titleProperty}>All</Text>
                                            </label>
                                            {
                                              twigSubcategories.map((subcategory) =>
                                                <>
                                                  <label className="radio" key={subcategory.id}>
                                                    <input type="radio" name="subcategory" checked={twigSubcategoryId == subcategory.id} onChange={e => handleChangeTwigSubcategory(subcategory)} ></input>
                                                    <Text as="span" className={classes.titleProperty}>{subcategory.name}
                                                      <Text as="span" fontSize="size1" className={classes.titleCountProperty}>({subcategory.products_count})</Text>

                                                    </Text>
                                                  </label>
                                                </>
                                              )
                                            }
                                          </>
                                        </Accordion.Collapse>
                                      </Accordion>
                                    </div>
                                  </>
                                  : null
                              }
                            </>
                            :
                            <>
                              <div className={classes.property}>
                                <Accordion className={classes.accordion} defaultActiveKey="OC">

                                  <Accordion.Toggle eventKey="OC">
                                    <Text as="span" className={classes.textProperty} bold>Category</Text>
                                    <FiChevronRight></FiChevronRight>

                                  </Accordion.Toggle>
                                  <Accordion.Collapse eventKey="OC">
                                    <>                                <label className="radio">
                                      <input type="radio" name="category" onChange={e => handleChangeOfferCategory(null)} checked={offerCategoryId == null} value=""></input>
                                      <Text as="span" className={classes.titleProperty}>All
                                      </Text>
                                    </label>

                                      {
                                        offerCategories.map((category) =>
                                          <>
                                            <label className="radio" key={category.id}>
                                              <input type="radio" name="category" onChange={e => handleChangeOfferCategory(category)} checked={offerCategoryId == category.id} ></input>
                                              <Text as="span" className={classes.titleProperty}>{category.name}
                                              </Text>
                                            </label>
                                          </>
                                        )
                                      }
                                    </>
                                  </Accordion.Collapse>
                                </Accordion>
                              </div>




                              {
                                offerSubcategories.length != 0 ?
                                  <>
                                    <div className={classes.property}>
                                      <Accordion className={classes.accordion} defaultActiveKey="OS">

                                        <Accordion.Toggle eventKey="OS">
                                          <Text as="span" className={classes.textProperty} bold>Sub Category</Text>
                                          <FiChevronRight></FiChevronRight>

                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="OS">
                                          <>
                                            <label className="radio">
                                              <input type="radio" name="subcategory" onChange={e => handleChangeOfferSubcategory(null)} checked={offerSubcategoryId == null} value=""></input>
                                              <Text as="span" className={classes.titleProperty}>All</Text>
                                            </label>
                                            {
                                              offerSubcategories.map((subcategory) =>
                                                <>
                                                  <label className="radio" key={subcategory.id}>
                                                    <input type="radio" name="subcategory" checked={offerSubcategoryId == subcategory.id} onChange={e => handleChangeOfferSubcategory(subcategory)} ></input>
                                                    <Text as="span" className={classes.titleProperty}>{subcategory.name}
                                                      <Text as="span" fontSize="size1" className={classes.titleCountProperty}>({subcategory.products_count})</Text>

                                                    </Text>
                                                  </label>
                                                </>
                                              )
                                            }
                                          </>
                                        </Accordion.Collapse>
                                      </Accordion>
                                    </div>
                                  </>
                                  : null
                              }
                            </>
                      }

                      <div className={classes.property}>
                        {
                          selectedTab == 'products' ?
                            <>
                              {
                                rangProductPrice != null && rangProductPrice['max'] != rangProductPrice['min'] ?
                                  <>
                                    {/* <Accordion className={classes.accordion} activeKey={defaultActiveKey}>

                                      <Accordion.Toggle eventKey="PP"> */}
                                    <Text as="span" className={classes.textProperty} bold>Price</Text>
                                    {/* <FiChevronRight></FiChevronRight>

                                      </Accordion.Toggle>
                                      <Accordion.Collapse eventKey="PP"> */}
                                    <div className={classes.inputRange}>
                                      <InputRange maxValue={rangProductPrice.max}
                                        minValue={rangProductPrice.min}
                                        value={productPrice}
                                        onChange={value => setProductPrice(value)}
                                        onChangeComplete={value => handelChangeProductsPrice(value)}
                                      />
                                    </div>

                                    {/* </Accordion.Collapse>
                                    </Accordion> */}
                                  </>

                                  : null
                              }
                            </>
                            :
                            selectedTab == 'twigs' ?

                              <>
                                {
                                  rangTwigPrice != null && rangTwigPrice['max'] != rangTwigPrice['min'] ?
                                    <>

                                      {/* <Accordion className={classes.accordion} activeKey={defaultActiveKey}>

                                        <Accordion.Toggle eventKey="PT"> */}
                                      <Text as="span" className={classes.textProperty} bold>Price</Text>
                                      {/* <FiChevronRight></FiChevronRight>

                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="PT"> */}

                                      <div className={classes.inputRange}>
                                        <InputRange maxValue={rangTwigPrice.max}
                                          minValue={rangTwigPrice.min}
                                          value={twigPrice}
                                          onChange={value => setTwigPrice(value)}
                                          // onChange={value => console.log(value)}
                                          onChangeComplete={value => handelChangeTwigsPrice(value)}
                                        />
                                      </div>
                                      {/* </Accordion.Collapse>
                                      </Accordion> */}
                                    </>

                                    : null
                                }
                              </>
                              :
                              <>
                                {
                                  rangOfferPrice != null && rangOfferPrice['max'] != rangOfferPrice['min'] ?
                                    <>
                                      {/* <Accordion className={classes.accordion} activeKey={defaultActiveKey}>

                                        <Accordion.Toggle eventKey="PO"> */}
                                      <Text as="span" className={classes.textProperty} bold>Price</Text>
                                      {/* <FiChevronRight></FiChevronRight>

                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="PO"> */}
                                      <div className={classes.inputRange}>
                                        <InputRange maxValue={rangOfferPrice.max}
                                          minValue={rangOfferPrice.min}
                                          value={offerPrice}
                                          onChange={value => setOfferPrice(value)}
                                          // onChange={value => console.log(value)}
                                          onChangeComplete={value => handelChangeOffersPrice(value)}
                                        />
                                      </div>
                                      {/* </Accordion.Collapse>
                                      </Accordion> */}
                                    </>

                                    : null
                                }
                              </>
                        }
                      </div>

                      {
                        selectedTab == "products" ?
                          <>

                            {
                              productGenders.length != 0 ?
                                <>
                                  <div className={classes.property}>

                                    <Accordion className={classes.accordion} defaultActiveKey="PG">

                                      <Accordion.Toggle eventKey="PG">
                                        <Text as="span" className={classes.textProperty} bold>Gender</Text>
                                        <FiChevronRight></FiChevronRight>

                                      </Accordion.Toggle>
                                      <Accordion.Collapse eventKey="PG">
                                        <>

                                          <label className="radio">
                                            <input type="radio" name="gender" onChange={e => handleChangeProductGender(null)} checked={productGender == null} value=""></input>
                                            <Text as="span" className={classes.titleProperty}>All
                                            </Text>
                                          </label>
                                          {
                                            productGenders.map((gender) =>
                                              <>
                                                <label className="radio" key={gender.gender}>
                                                  <input type="radio" name="gender" checked={productGender == gender.gender} onChange={e => handleChangeProductGender(gender.gender)} ></input>
                                                  <Text as="span" className={classes.titleProperty}>{gender.label}
                                                    <Text as="span" fontSize="size1" className={classes.titleCountProperty}>({gender.total})</Text>

                                                  </Text>
                                                </label>
                                              </>
                                            )
                                          }
                                        </>
                                      </Accordion.Collapse>
                                    </Accordion>
                                  </div>
                                </>
                                : null
                            }

                            {
                              productBrands.length != 0 ?
                                <>
                                  <div className={classes.property}>
                                    <Accordion className={classes.accordion} defaultActiveKey="PB">

                                      <Accordion.Toggle eventKey="PB">
                                        <Text as="span" className={classes.textProperty} bold>Brand</Text>
                                        <FiChevronRight></FiChevronRight>

                                      </Accordion.Toggle>
                                      <Accordion.Collapse eventKey="PB">
                                        <>
                                          <input type="text" className={classes.inputSearch}
                                            name="item"
                                            placeholder="Search"
                                            value={productSearchBrand}
                                            onChange={e => handleChangeProductSearchBrand(e.target.value)}
                                          // onKeyDown={e => handleSubmitSearchKey(e)}
                                          />
                                          <div className={classes.listProperty}>
                                            <label className="radio">
                                              <input type="radio" name="brand" onChange={e => handleChangeProductBrand(null)} checked={productBrandId == null} value=""></input>
                                              <Text as="span" className={classes.titleProperty}>All
                                              </Text>
                                            </label>


                                            {
                                              productBrands
                                                .filter(brand => brand.name.toLowerCase().includes(productSearchBrand.toLowerCase()))
                                                .map((brand) =>
                                                  <>
                                                    <label className="radio" key={brand.id}>
                                                      <input type="radio" name="brand" checked={productBrandId == brand.id} onChange={e => handleChangeProductBrand(brand)} ></input>
                                                      <Text as="span" className={classes.titleProperty}>{brand.name}
                                                        <Text as="span" fontSize="size1" className={classes.titleCountProperty}>({brand.products_count})</Text>

                                                      </Text>
                                                    </label>
                                                  </>
                                                )
                                            }
                                          </div>
                                        </>
                                      </Accordion.Collapse>
                                    </Accordion>
                                  </div>
                                </>
                                : null
                            }

                            {
                              productBusinesses.length != 0 ?
                                <>
                                  <div className={classes.property}>
                                    <Accordion className={classes.accordion} defaultActiveKey="PB">

                                      <Accordion.Toggle eventKey="PB">
                                        <Text as="span" className={classes.textProperty} bold>Business</Text>
                                        <FiChevronRight></FiChevronRight>

                                      </Accordion.Toggle>
                                      <Accordion.Collapse eventKey="PB">
                                        <>
                                          <input type="text" className={classes.inputSearch}
                                            name="item"
                                            placeholder="Search"
                                            value={productSearchBusiness}
                                            onChange={e => handleChangeProductSearchBusiness(e.target.value)}
                                          // onKeyDown={e => handleSubmitSearchKey(e)}
                                          />
                                          <div className={classes.listProperty}>
                                            <label className="radio">
                                              <input type="radio" name="business" onChange={e => handleChangeProductBusiness(null)} checked={productBusinessId == null} value=""></input>
                                              <Text as="span" className={classes.titleProperty}>All
                                              </Text>
                                            </label>


                                            {
                                              productBusinesses
                                                .filter(business => business.name.toLowerCase().includes(productSearchBusiness.toLowerCase()))
                                                .map((business) =>
                                                  <>
                                                    <label className="radio" key={business.id}>
                                                      <input type="radio" name="business" checked={productBusinessId == business.id} onChange={e => handleChangeProductBusiness(business)} ></input>
                                                      <Text as="span" className={classes.titleProperty}>{business.name}
                                                        <Text as="span" fontSize="size1" className={classes.titleCountProperty}>({business.products_count})</Text>

                                                      </Text>
                                                    </label>
                                                  </>
                                                )
                                            }
                                          </div>
                                        </>
                                      </Accordion.Collapse>
                                    </Accordion>
                                  </div>
                                </>
                                : null
                            }


                            {

                              productsOption.map((property) =>
                                property.option_values.length != 0 ?
                                  <>
                                    <div className={classes.property} key={property.id}>

                                      <Accordion className={classes.accordion} defaultActiveKey={"PP" + property.id}>

                                        <Accordion.Toggle eventKey={"PP" + property.id}>
                                          <Text as="span" className={classes.textProperty} bold>{property.name}
                                          </Text>
                                          <FiChevronRight></FiChevronRight>

                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey={"PP" + property.id}>
                                          <>
                                            {
                                              property.name != "Color" ?
                                                <>
                                                  <label className="radio">
                                                    <input type="radio" name={property.id} checked={productsOptionSelected[property.id] == null} onChange={e => handleChangeProductFilter(property.id, null)} value=""></input>
                                                    <Text as="span" className={classes.titleProperty}>All

                                                    </Text>
                                                  </label>
                                                  {
                                                    property.option_values.map((option: any) =>
                                                      <label className="radio" key={option.id}>
                                                        <input type="radio" checked={productsOptionSelected[property.id] != null && productsOptionSelected[property.id].id == option.id} onChange={e => handleChangeProductFilter(property.id, option)} name={property.id} value={option.id}></input>
                                                        <Text as="span" className={classes.titleProperty}>{option.title ? option.title : option.value}
                                                          <Text as="span" fontSize="size1" className={classes.titleCountProperty}>({option.products_count})</Text>
                                                        </Text>
                                                      </label>
                                                    )
                                                  }
                                                </> :
                                                <>
                                                  <ul className={classes.colorList}>
                                                    {/* my */}
                                                    {
                                                      property.option_values.map((option: any) =>
                          
                                                        <li onClick={e => handleChangeProductFilter(property.id, option)}
                                                          className={`${classes.oneColor} ${productsOptionSelected[property.id] != undefined && productsOptionSelected[property.id] != null && productsOptionSelected[property.id].id == option.id ? classes.selectedColor : ""}`}
                                                          // className={classes.oneColor + " " + productsOptionSelected[property.id] != undefined && productsOptionSelected[property.id] != null && productsOptionSelected[property.id].id == option.id ? classes.selectedColor : ''} 
                                                          style={{ backgroundColor: "#" + option.value }}></li>
                                                      )
                                                    }
                                                    
                                                  </ul>
                                                </>
                                            }

                                          </>
                                        </Accordion.Collapse>
                                      </Accordion>
                                    </div>
                                  </>
                                  : null)
                            }
                          </>
                          :
                          selectedTab == 'twigs' ?
                            <>

                              {
                                twigGenders.length != 0 ?
                                  <>
                                    <div className={classes.property}>
                                      <Accordion className={classes.accordion} defaultActiveKey="TG">
                                        <Accordion.Toggle eventKey="TG">
                                          <Text as="span" className={classes.textProperty} bold>Gender</Text>
                                          <FiChevronRight></FiChevronRight>

                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="TG">
                                          <>
                                            <label className="radio">
                                              <input type="radio" name="gender" onChange={e => handleChangeTwigGender(null)} checked={twigGender == null} value=""></input>
                                              <Text as="span" className={classes.titleProperty}>All
                                              </Text>
                                            </label>
                                            {
                                              twigGenders.map((gender) =>
                                                <>
                                                  <label className="radio" key={gender.gender}>
                                                    <input type="radio" name="gender" checked={twigGender == gender.gender} onChange={e => handleChangeTwigGender(gender.gender)} ></input>
                                                    <Text as="span" className={classes.titleProperty}>{gender.label}
                                                      <Text as="span" fontSize="size1" className={classes.titleCountProperty}>({gender.total})</Text>

                                                    </Text>
                                                  </label>
                                                </>
                                              )
                                            }
                                          </>
                                        </Accordion.Collapse>
                                      </Accordion>
                                    </div>
                                  </>
                                  : null
                              }

                              {
                                twigBrands.length != 0 ?
                                  <>
                                    <div className={classes.property}>
                                      <Accordion className={classes.accordion} defaultActiveKey="TB">
                                        <Accordion.Toggle eventKey="TB">
                                          <Text as="span" className={classes.textProperty} bold>Brand</Text>
                                          <FiChevronRight></FiChevronRight>

                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="TB">
                                          <>
                                            <input type="text" className={classes.inputSearch}
                                              name="item"
                                              placeholder="Search"
                                              value={twigSearchBrand}
                                              onChange={e => handleChangeTwigSearchBrand(e.target.value)}
                                            // onKeyDown={e => handleSubmitSearchKey(e)}
                                            />
                                            <div className={classes.listProperty}>
                                              <label className="radio">
                                                <input type="radio" name="brand" onChange={e => handleChangeTwigBrand(null)} checked={twigBrandId == null} value=""></input>
                                                <Text as="span" className={classes.titleProperty}>All
                                                </Text>
                                              </label>


                                              {
                                                twigBrands
                                                  .filter(brand => brand.name.toLowerCase().includes(twigSearchBrand.toLowerCase()))
                                                  .map((brand) =>
                                                    <>
                                                      <label className="radio" key={brand.id}>
                                                        <input type="radio" name="brand" checked={twigBrandId == brand.id} onChange={e => handleChangeTwigBrand(brand)} ></input>
                                                        <Text as="span" className={classes.titleProperty}>{brand.name}
                                                          <Text as="span" fontSize="size1" className={classes.titleCountProperty}>({brand.twigs_count})</Text>

                                                        </Text>
                                                      </label>
                                                    </>
                                                  )
                                              }
                                            </div>
                                          </>
                                        </Accordion.Collapse>
                                      </Accordion>
                                    </div>
                                  </>
                                  : null
                              }

                              {
                                twigBusinesses.length != 0 ?
                                  <>
                                    <div className={classes.property}>
                                      <Accordion className={classes.accordion} defaultActiveKey="TB">
                                        <Accordion.Toggle eventKey="TB">
                                          <Text as="span" className={classes.textProperty} bold>Business</Text>
                                          <FiChevronRight></FiChevronRight>

                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="TB">
                                          <>
                                            <input type="text" className={classes.inputSearch}
                                              name="item"
                                              placeholder="Search"
                                              value={twigSearchBusiness}
                                              onChange={e => handleChangeTwigSearchBusiness(e.target.value)}
                                            // onKeyDown={e => handleSubmitSearchKey(e)}
                                            />
                                            <div className={classes.listProperty}>
                                              <label className="radio">
                                                <input type="radio" name="business" onChange={e => handleChangeTwigBusiness(null)} checked={twigBusinessId == null} value=""></input>
                                                <Text as="span" className={classes.titleProperty}>All
                                                </Text>
                                              </label>


                                              {
                                                twigBusinesses
                                                  .filter(business => business.name.toLowerCase().includes(twigSearchBusiness.toLowerCase()))
                                                  .map((business) =>
                                                    <>
                                                      <label className="radio" key={business.id}>
                                                        <input type="radio" name="business" checked={twigBusinessId == business.id} onChange={e => handleChangeTwigBusiness(business)} ></input>
                                                        <Text as="span" className={classes.titleProperty}>{business.name}
                                                          <Text as="span" fontSize="size1" className={classes.titleCountProperty}>({business.twigs_count})</Text>

                                                        </Text>
                                                      </label>
                                                    </>
                                                  )
                                              }
                                            </div>
                                          </>
                                        </Accordion.Collapse>
                                      </Accordion>
                                    </div>
                                  </>
                                  : null
                              }



                              {

                                twigsOption.map((property) =>
                                  property.option_values.length != 0 ?
                                    <>
                                      <div className={classes.property} key={property.id}>
                                        <Accordion className={classes.accordion} defaultActiveKey={"TP" + property.id}>
                                          <Accordion.Toggle eventKey={"TP" + property.id}>
                                            <Text as="span" className={classes.textProperty} bold>{property.name}</Text>
                                            <FiChevronRight></FiChevronRight>

                                          </Accordion.Toggle>
                                          <Accordion.Collapse eventKey={"TP" + property.id}>
                                            <>
                                              {
                                                property.name != "Color" ?
                                                  <>
                                                    <label className="radio">
                                                      <input type="radio" name={property.id} checked={twigsOptionSelected[property.id] == null} onChange={e => handleChangeTwigFilter(property.id, null)} value=""></input>
                                                      <Text as="span" className={classes.titleProperty}>All
                                                      </Text>
                                                    </label>
                                                    {
                                                      property.option_values.map((option: any) =>
                                                        <label className="radio" key={option.id}>
                                                          <input type="radio" checked={twigsOptionSelected[property.id] != null && twigsOptionSelected[property.id].id == option.id} onChange={e => handleChangeTwigFilter(property.id, option)} name={property.id} value={option.id}></input>
                                                          <Text as="span" className={classes.titleProperty}>{option.title ? option.title : option.value}
                                                            <Text as="span" fontSize="size1" className={classes.titleCountProperty}>({option.products_count})</Text>
                                                          </Text>
                                                        </label>
                                                      )
                                                    }
                                                  </> :
                                                  <>
                                                    <ul className={classes.colorList}>
                                                      {
                                                        property.option_values.map((option: any) =>
                                                          <li onClick={e => handleChangeTwigFilter(property.id, option)}
                                                            className={`${classes.oneColor} ${twigsOptionSelected[property.id] != undefined && twigsOptionSelected[property.id] != null && twigsOptionSelected[property.id].id == option.id ? classes.selectedColor : ""}`}
                                                            // className={classes.oneColor + " " + productsOptionSelected[property.id] != undefined && productsOptionSelected[property.id] != null && productsOptionSelected[property.id].id == option.id ? classes.selectedColor : ''} 
                                                            style={{ backgroundColor: "#" + option.value }}></li>
                                                        )
                                                      }
                                                    </ul>
                                                  </>
                                              }
                                            </>
                                          </Accordion.Collapse>
                                        </Accordion>
                                      </div>
                                    </>
                                    : null)
                              }
                            </>
                            : <>


                              {
                                offerGenders.length != 0 ?
                                  <>
                                    <div className={classes.property}>
                                      <Accordion className={classes.accordion} defaultActiveKey="PG">

                                        <Accordion.Toggle eventKey="PG">
                                          <Text as="span" className={classes.textProperty} bold>Gender</Text>
                                          <FiChevronRight></FiChevronRight>

                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="PG">
                                          <>                                      <label className="radio">
                                            <input type="radio" name="gender" onChange={e => handleChangeOfferGender(null)} checked={offerGender == null} value=""></input>
                                            <Text as="span" className={classes.titleProperty}>All</Text>
                                          </label>
                                            {
                                              offerGenders.map((gender) =>
                                                <>
                                                  <label className="radio" key={gender.gender}>
                                                    <input type="radio" name="gender" checked={offerGender == gender.gender} onChange={e => handleChangeOfferGender(gender.gender)} ></input>
                                                    <Text as="span" className={classes.titleProperty}>{gender.label}
                                                      <Text as="span" fontSize="size1" className={classes.titleCountProperty}>({gender.total})</Text>

                                                    </Text>
                                                  </label>
                                                </>
                                              )
                                            }
                                          </>
                                        </Accordion.Collapse>
                                      </Accordion>
                                    </div>
                                  </>
                                  : null
                              }

                              {
                                offerBrands.length != 0 ?
                                  <>
                                    <div className={classes.property}>
                                      <Accordion className={classes.accordion} defaultActiveKey="PB">

                                        <Accordion.Toggle eventKey="PB">
                                          <Text as="span" className={classes.textProperty} bold>Brand</Text>
                                          <FiChevronRight></FiChevronRight>

                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="PB">
                                          <>
                                            <input type="text" className={classes.inputSearch}
                                              name="item"
                                              placeholder="Search"
                                              value={offerSearchBrand}
                                              onChange={e => handleChangeOfferSearchBrand(e.target.value)}
                                            // onKeyDown={e => handleSubmitSearchKey(e)}
                                            />
                                            <div className={classes.listProperty}>
                                              <label className="radio">
                                                <input type="radio" name="brand" onChange={e => handleChangeOfferBrand(null)} checked={offerBrandId == null} value=""></input>
                                                <Text as="span" className={classes.titleProperty}>All</Text>
                                              </label>
                                              {
                                                offerBrands
                                                  .filter(brand => brand.name.toLowerCase().includes(offerSearchBrand.toLowerCase()))
                                                  .map((brand) =>
                                                    <>
                                                      <label className="radio" key={brand.id}>
                                                        <input type="radio" name="brand" checked={offerBrandId == brand.id} onChange={e => handleChangeOfferBrand(brand)} ></input>
                                                        <Text as="span" className={classes.titleProperty}>{brand.name}
                                                          <Text as="span" fontSize="size1" className={classes.titleCountProperty}>({brand.products_count})</Text>

                                                        </Text>
                                                      </label>
                                                    </>
                                                  )
                                              }
                                            </div>
                                          </>
                                        </Accordion.Collapse>
                                      </Accordion>
                                    </div>
                                  </>
                                  : null
                              }

                              {
                                offerBusinesses.length != 0 ?
                                  <>
                                    <div className={classes.property}>
                                      <Accordion className={classes.accordion} defaultActiveKey="PB">

                                        <Accordion.Toggle eventKey="PB">
                                          <Text as="span" className={classes.textProperty} bold>Business</Text>
                                          <FiChevronRight></FiChevronRight>

                                        </Accordion.Toggle>
                                        <Accordion.Collapse eventKey="PB">
                                          <>
                                            <input type="text" className={classes.inputSearch}
                                              name="item"
                                              placeholder="Search"
                                              value={offerSearchBusiness}
                                              onChange={e => handleChangeOfferSearchBusiness(e.target.value)}
                                            // onKeyDown={e => handleSubmitSearchKey(e)}
                                            />
                                            <div className={classes.listProperty}>
                                              <label className="radio">
                                                <input type="radio" name="business" onChange={e => handleChangeOfferBusiness(null)} checked={offerBusinessId == null} value=""></input>
                                                <Text as="span" className={classes.titleProperty}>All</Text>
                                              </label>
                                              {
                                                offerBusinesses
                                                  .filter(business => business.name.toLowerCase().includes(offerSearchBusiness.toLowerCase()))
                                                  .map((business) =>
                                                    <>
                                                      <label className="radio" key={business.id}>
                                                        <input type="radio" name="business" checked={offerBusinessId == business.id} onChange={e => handleChangeOfferBusiness(business)} ></input>
                                                        <Text as="span" className={classes.titleProperty}>{business.name}
                                                          <Text as="span" fontSize="size1" className={classes.titleCountProperty}>({business.products_count})</Text>

                                                        </Text>
                                                      </label>
                                                    </>
                                                  )
                                              }
                                            </div>
                                          </>
                                        </Accordion.Collapse>
                                      </Accordion>
                                    </div>
                                  </>
                                  : null
                              }



                              {

                                offersOption.map((property) =>
                                  property.option_values.length != 0 ?
                                    <>
                                      <div className={classes.property} key={property.id}>
                                        <Accordion className={classes.accordion} defaultActiveKey={"PO" + property.id}>

                                          <Accordion.Toggle eventKey={"PO" + property.id}>
                                            <Text as="span" className={classes.textProperty} bold>{property.name}</Text>
                                            <FiChevronRight></FiChevronRight>

                                          </Accordion.Toggle>
                                          <Accordion.Collapse eventKey={"PO" + property.id}>
                                            <>
                                              {
                                                property.name != "Color" ?
                                                  <>
                                                    <label className="radio">
                                                      <input type="radio" name={property.id} checked={offersOptionSelected[property.id] == null} onChange={e => handleChangeOfferFilter(property.id, null)} value=""></input>
                                                      <Text as="span" className={classes.titleProperty}>All
                                                      </Text>
                                                    </label>
                                                    {
                                                      property.option_values.map((option: any) =>
                                                        <label className="radio" key={option.id}>
                                                          <input type="radio" checked={offersOptionSelected[property.id] != null && offersOptionSelected[property.id].id == option.id} onChange={e => handleChangeOfferFilter(property.id, option)} name={property.id} value={option.id}></input>
                                                          <Text as="span" className={classes.titleProperty}>{option.title ? option.title : option.value}
                                                            <Text as="span" fontSize="size1" className={classes.titleCountProperty}>({option.products_count})</Text>
                                                          </Text>
                                                        </label>
                                                      )
                                                    }
                                                  </> :
                                                  <>
                                                    <ul className={classes.colorList}>
                                                      
                                                      {
                                                        property.option_values.map((option: any) =>
                                                          <li onClick={e => handleChangeOfferFilter(property.id, option)}
                                                            className={`${classes.oneColor} ${offersOptionSelected[property.id] != undefined && offersOptionSelected[property.id] != null && offersOptionSelected[property.id].id == option.id ? classes.selectedColor : ""}`}
                                                            // className={classes.oneColor + " " + productsOptionSelected[property.id] != undefined && productsOptionSelected[property.id] != null && productsOptionSelected[property.id].id == option.id ? classes.selectedColor : ''} 
                                                            style={{ backgroundColor: "#" + option.value }}></li>
                                                        )
                                                      }
                                                    </ul>
                                                  </>
                                              }
                                            </>
                                          </Accordion.Collapse>
                                        </Accordion>
                                      </div>
                                    </>
                                    : null)
                              }
                            </>

                      }

                      <div className={classes.doneDev} onClick={() => setViewFilter(false)}>
                        <Text as="h4" color="white">
                          Done
                        </Text>
                      </div>
                    </div>
                    {/* </Col> */}
                    {/* <Col md={10} xs={12}> */}
                  </div>

                  <div className={classes.containtCol}>

                    <div className={classes.orders}>
                      <Text as="h3" bold className={classes.searchFor}>
                        Search Results
                        {
                          selectedTab == "products" && productSelectedCategory ? " for " + productSelectedCategory.name
                            : selectedTab == "twigs" && twigSelectedCategory ? " for " + twigSelectedCategory.name
                              : selectedTab == "offers" && offerSelectedCategory ? " for " + offerSelectedCategory.name
                                : searchKey ? " for " + searchKey
                                  : null
                        }
                      </Text>
                      <div className={classes.orderDiv}>
                        {
                          selectedTab == "products" ?
                            <>
                              <Text as="span" className={classes.productCount} >
                                Showing {products.length} products of {productTotalCount}
                              </Text>
                              {/* <Select
                                className={classes.select}
                                value={null}
                                options={[]}
                                inputValue="Order By"
                                styles={{
                                  control: (styles) => ({
                                    ...styles,
                                    border: 'none',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                  }),
                                  indicatorSeparator: () => ({ display: 'none' }),
                                }}
                                onChange={handleChangeAddress}
                              ></Select> */}
                            </>
                            :
                            selectedTab == "twigs" ?
                              <>
                                <Text as="span" className={classes.productCount} >
                                  Showing {twigs.length} twigs of {twigTotalCount}
                                </Text>
                                {/* <Select
                                className={classes.select}
                                value={null}
                                options={[]}
                                inputValue="Order By"
                                styles={{
                                  control: (styles) => ({
                                    ...styles,
                                    border: 'none',
                                    fontWeight: 'bold',
                                    cursor: 'pointer',
                                  }),
                                  indicatorSeparator: () => ({ display: 'none' }),
                                }}
                                onChange={handleChangeAddress}
                              ></Select> */}
                              </>
                              :
                              <>
                                <Text as="span" className={classes.productCount} >
                                  Showing {offers.length} offers of {offerTotalCount}
                                </Text>
                                {/* <Select
                              className={classes.select}
                              value={null}
                              options={[]}
                              inputValue="Order By"
                              styles={{
                                control: (styles) => ({
                                  ...styles,
                                  border: 'none',
                                  fontWeight: 'bold',
                                  cursor: 'pointer',
                                }),
                                indicatorSeparator: () => ({ display: 'none' }),
                              }}
                              onChange={handleChangeAddress}
                            ></Select> */}
                              </>
                        }
                        <div className={classes.divFilterIcon} onClick={() => openFilter()}>

                          <div className={classes.filterIcon}></div>
                        </div>
                        {/* <BsFilter className={classes.filterIcon} onClick={() => openFilter()}></BsFilter> */}
                      </div>
                    </div>
                    <Row>
                      <Col lg={12}>
                        {/* <Text as="span">22 offer</Text> */}
                        <ul className={classes.listTags}>
                          {
                            searchKey && searchKey != "" ?
                              <li className={classes.tag}>{searchKey}
                                <AiOutlineClose onClick={() =>
                                  clearSearchKey()
                                } className={classes.tagIcon}></AiOutlineClose>
                              </li>

                              : null
                          }

                          {
                            selectedTab == "products" ?
                              <>
                                {
                                  rangProductPriceChanged != 0 ?
                                    <li className={classes.tag}>{productPrice.min + " ~ " + productPrice.max}
                                      <AiOutlineClose onClick={() =>
                                        deleteProductsPrice()
                                      } className={classes.tagIcon}></AiOutlineClose>

                                    </li>
                                    : null
                                }

                                {
                                  productSelectedBrand ?
                                    <li className={classes.tag}>
                                      {productSelectedBrand.name}
                                      <AiOutlineClose onClick={() =>
                                        handleChangeProductBrand(null)
                                      } className={classes.tagIcon}></AiOutlineClose>
                                    </li>
                                    : null
                                }

                                {productSelectedBusiness ?
                                  <li className={classes.tag}>
                                    {productSelectedBusiness.name}
                                    <AiOutlineClose onClick={() =>
                                      handleChangeProductBusiness(null)
                                    } className={classes.tagIcon}></AiOutlineClose>
                                  </li>
                                  : null
                                }

                                {
                                  productSelectedCategory ?
                                    <li className={classes.tag}>
                                      {productSelectedCategory.name}
                                      <AiOutlineClose onClick={() =>
                                        handleChangeProductCategory(null)
                                      } className={classes.tagIcon}></AiOutlineClose>
                                    </li>
                                    : null
                                }

                                {
                                  productSelectedSubcategory ?
                                    <li className={classes.tag}>
                                      {productSelectedSubcategory.name}
                                      <AiOutlineClose onClick={() =>
                                        handleChangeProductSubcategory(null)
                                      } className={classes.tagIcon}></AiOutlineClose>
                                    </li>
                                    : null
                                }

                                {
                                  productGender ?
                                    <li className={classes.tag}>
                                      {productGender == "Male" ? "Men" : "Women"}
                                      <AiOutlineClose onClick={() =>
                                        handleChangeProductGender(null)
                                      } className={classes.tagIcon}></AiOutlineClose>
                                    </li>
                                    : null
                                }
                                {
                                  productsOptionSelected.map((item, index) => (
                                    // {
                                    item != null ?
                                      <>
                                        <li className={classes.tag} key={index}>{item.title ? item.title : item.value}
                                          <AiOutlineClose onClick={() =>
                                            deleteProductsOption(item.id)
                                          } className={classes.tagIcon}></AiOutlineClose>
                                        </li>
                                      </>
                                      : null
                                    // }
                                  )
                                  )
                                }

                                {
                                  productTags != "" ?
                                    productTags.split(",").map((item, index) => (
                                      <li className={classes.tag} key={index}>{item}
                                        <AiOutlineClose onClick={() =>
                                          handleChangeProductsTag(item)
                                        } className={classes.tagIcon}></AiOutlineClose>
                                      </li>
                                    )) : null
                                }
                              </>
                              :
                              selectedTab == "twigs" ?

                                <>
                                  {
                                    rangTwigPriceChanged != 0 ?
                                      <li className={classes.tag}>{twigPrice.min + " ~ " + twigPrice.max}
                                        <AiOutlineClose onClick={() =>
                                          deleteTwigsPrice()
                                        } className={classes.tagIcon}></AiOutlineClose>

                                      </li>
                                      : null
                                  }

                                  {
                                    twigSelectedBrand ?
                                      <li className={classes.tag}>
                                        {twigSelectedBrand.name}
                                        <AiOutlineClose onClick={() =>
                                          handleChangeTwigBrand(null)
                                        } className={classes.tagIcon}></AiOutlineClose>
                                      </li>
                                      : null
                                  }

                                  {
                                    twigSelectedBusiness ?
                                      <li className={classes.tag}>
                                        {twigSelectedBusiness.name}
                                        <AiOutlineClose onClick={() =>
                                          handleChangeTwigBusiness(null)
                                        } className={classes.tagIcon}></AiOutlineClose>
                                      </li>
                                      : null
                                  }


                                  {
                                    twigSelectedCategory ?
                                      <li className={classes.tag}>
                                        {twigSelectedCategory.name}
                                        <AiOutlineClose onClick={() =>
                                          handleChangeTwigCategory(null)
                                        } className={classes.tagIcon}></AiOutlineClose>
                                      </li>
                                      : null
                                  }

                                  {
                                    twigSelectedSubcategory ?
                                      <li className={classes.tag}>
                                        {twigSelectedSubcategory.name}
                                        <AiOutlineClose onClick={() =>
                                          handleChangeTwigSubcategory(null)
                                        } className={classes.tagIcon}></AiOutlineClose>
                                      </li>
                                      : null
                                  }

                                  {
                                    twigGender ?
                                      <li className={classes.tag}>
                                        {twigGender == "Male" ? "Men" : "Women"}
                                        <AiOutlineClose onClick={() =>
                                          handleChangeTwigGender("")
                                        } className={classes.tagIcon}></AiOutlineClose>
                                      </li>
                                      : null
                                  }
                                  {
                                    twigTags != "" ?
                                      twigTags.split(",").map((item, index) => (
                                        <li className={classes.tag} key={index}>{item}
                                          <AiOutlineClose onClick={() =>
                                            handleChangeTwigTag(item)
                                          } className={classes.tagIcon}></AiOutlineClose>
                                        </li>
                                      )) : null
                                  }

                                  {

                                    twigsOptionSelected.map((item, index) => (
                                      // {
                                      item != null ?
                                        <>
                                          <li className={classes.tag} key={item.id}>{item.title ? item.title : item.value}
                                            <AiOutlineClose onClick={() =>
                                              deleteTwigsOption(index)
                                            } className={classes.tagIcon}></AiOutlineClose>
                                          </li>
                                        </>
                                        : null
                                      // }
                                    )
                                    )
                                  }
                                </>
                                :
                                <>
                                  {
                                    rangOfferPriceChanged != 0 ?
                                      <li className={classes.tag}>{offerPrice.min + " ~ " + offerPrice.max}
                                        <AiOutlineClose onClick={() =>
                                          deleteOffersPrice()
                                        } className={classes.tagIcon}></AiOutlineClose>

                                      </li>
                                      : null
                                  }

                                  {
                                    offerSelectedBrand ?
                                      <li className={classes.tag}>
                                        {offerSelectedBrand.name}
                                        <AiOutlineClose onClick={() =>
                                          handleChangeOfferBrand(null)
                                        } className={classes.tagIcon}></AiOutlineClose>
                                      </li>
                                      : null
                                  }

                                  {
                                    offerSelectedBusiness ?
                                      <li className={classes.tag}>
                                        {offerSelectedBusiness.name}
                                        <AiOutlineClose onClick={() =>
                                          handleChangeOfferBusiness(null)
                                        } className={classes.tagIcon}></AiOutlineClose>
                                      </li>
                                      : null
                                  }

                                  {
                                    offerSelectedCategory ?
                                      <li className={classes.tag}>
                                        {offerSelectedCategory.name}
                                        <AiOutlineClose onClick={() =>
                                          handleChangeOfferCategory(null)
                                        } className={classes.tagIcon}></AiOutlineClose>
                                      </li>
                                      : null
                                  }

                                  {
                                    offerSelectedSubcategory ?
                                      <li className={classes.tag}>
                                        {offerSelectedSubcategory.name}
                                        <AiOutlineClose onClick={() =>
                                          handleChangeOfferSubcategory(null)
                                        } className={classes.tagIcon}></AiOutlineClose>
                                      </li>
                                      : null
                                  }

                                  {
                                    offerGender ?
                                      <li className={classes.tag}>
                                        {offerGender == "Male" ? "Men" : "Women"}
                                        <AiOutlineClose onClick={() =>
                                          handleChangeOfferGender("")
                                        } className={classes.tagIcon}></AiOutlineClose>
                                      </li>
                                      : null
                                  }
                                  {
                                    offerTags != "" ?
                                      offerTags.split(",").map((item, index) => (
                                        <li className={classes.tag} key={index}>{item}
                                          <AiOutlineClose onClick={() =>
                                            handleChangeOfferTag(item)
                                          } className={classes.tagIcon}></AiOutlineClose>
                                        </li>
                                      )) : null
                                  }
                                  {

                                    offersOptionSelected.map((item, index) => (
                                      // {
                                      item != null ?
                                        <>
                                          <li className={classes.tag} key={item.id}>{item.title ? item.title : item.value}
                                            <AiOutlineClose onClick={() =>
                                              deleteOffersOption(item.id)
                                            } className={classes.tagIcon}></AiOutlineClose>
                                          </li>
                                        </>
                                        : null
                                      // }
                                    )
                                    )
                                  }
                                </>
                          }
                        </ul>
                      </Col>
                    </Row>

                    <Row>
                      <Col lg={12}>
                        <div className={classes.tabs}>

                          <div className={clsx(classes.oneTab, selectedTab == 'twigs' ? classes.oneTabActive : "")}
                            onClick={() =>
                              handleChangeTab("twigs")
                            }
                          >
                            <Text as="span">twigs</Text>
                            {
                              selectedTab == 'twigs' ?
                                <div className={classes.circleActive}></div>
                                : null
                            }
                          </div>
                          <div className={classes.spreter}></div>

                          <div className={clsx(classes.oneTab, selectedTab == 'products' ? classes.oneTabActive : "")}
                            onClick={() =>
                              handleChangeTab("products")
                            }
                          >
                            <Text as="span">products</Text>
                            {
                              selectedTab == 'products' ?
                                <div className={classes.circleActive}></div>
                                : null
                            }
                          </div>
                          <div className={classes.spreter}></div>

                          <div className={clsx(classes.oneTab, selectedTab == 'offers' ? classes.oneTabActive : "")}
                            onClick={() =>
                              handleChangeTab("offers")
                            }
                          >
                            <Text as="span">offers</Text>
                            {
                              selectedTab == 'offers' ?
                                <div className={classes.circleActive}></div>
                                : null
                            }
                          </div>
                        </div>

                      </Col>
                    </Row>
                    {
                      selectedTab == 'twigs' ?
                        <>
                          <Masonry
                            breakpointCols={{
                              default: 3, 1100: 2, 700: 1,
                              500: 1
                            }}
                            columnClassName=""
                            className={classes.wrapper}
                          >
                            {twigs.map((twig) => (
                              <div key={twig.id}
                                className={classes.twigWrapper}
                              >
                                <TwigCard twig={twig} />
                              </div>
                            ))}
                          </Masonry>
                          <div className={classes.loadingMoreBox}>
                            {loadingMore ? <ClipLoader color="#522583" /> : null}
                          </div>
                        </>
                        :
                        selectedTab == 'products' ?

                          <>
                            <Masonry
                              breakpointCols={{
                                default: 3, 1100: 2, 700: 1,
                                500: 1
                              }}
                              columnClassName=""
                              className={classes.wrapper}
                            >
                              {products.map((product) => (
                                <div key={product.id}
                                  className={classes.twigWrapper}
                                >
                                  <ProductCard product={product} />
                                </div>
                              ))}
                            </Masonry>
                            <div className={classes.loadingMoreBox}>
                              {loadingMoreProduct ? <ClipLoader color="#522583" />: null}
                            </div>
                          </>
                          :
                          <>
                            <Masonry
                              breakpointCols={{
                                default: 3, 1100: 2, 700: 1,
                                500: 1
                              }}
                              columnClassName=""
                              className={classes.wrapper}
                            >
                              {offers.map((product) => (
                                <div key={product.id}
                                  className={classes.twigWrapper}
                                >
                                  <ProductCard product={product} />
                                </div>
                              ))}
                            </Masonry>
                            <div className={classes.loadingMoreBox}>
                              {loadingMoreProduct ? <ClipLoader color="#522583" /> : null}
                            </div>
                          </>

                    }
                    {/* </Col> */}
                  </div>
                </div>

                {/* </Row> */}

              </>
            )}
          </Loader>
        </Container>
      </DefaultLayout >
    </>
  );
};


const useStyles = createUseStyles({
  containtHeader: {
    maxWidth: '85vw',
    margin: "auto",
    paddingTop: "10px",
    '@media (max-width: 520px)': {
      maxWidth: 'inherit',
      "display": "flex",
      "flexFlow": "column"
    }
  },
  header: {
    backgroundColor: '#FFF',
    boxShadow: '0px 2px 6px #8686862b'
  },
  inputRange: {
    margin: "0px auto",
    padding: "30px 0px",
    width: "calc(100% - 25px)"
  },
  oneTabNav: {
    minHeight: "70px",
    backgroundColor: "white",
    borderBottom: "2px solid #9c9c9c8c"
  },
  oneTabNavTag: {
    color: "white",
    backgroundColor: "#522583",
    width: "fit-content",
    padding: "4px 15px",
    fontSize: "15px",
    borderRadius: "18px",
    fontWeight: "bold",
    margin: "0px auto",
    marginTop: "20px"
  },
  customHr: {
    margin: "10px 0px"
  },
  container: {

    // marginTop: "20px",
    // maxWidth: '95vw',
    '@media (max-width: 520px)': {
      maxWidth: 'inherit',
      padding: "0px"
    }
  },

  rowSeach: {
    // backgroundColor: "red",
    display: "flex",
    flexWrap: "wrap",
    marginRight: "-15px",
    marginLeft: "-15px"
  },
  filterCol: {
    backgroundColor: "white",
    position: "relative",
    marginLeft: "10px",
    width: "100%",
    paddingRight: "15px",
    paddingLeft: "15px",
    flex: "0 0 calc(20% - 10px)",
    maxWidth: "calc(20% - 10px)",
    boxShadow: "5px 0px 6px -3px grey"
  },
  containtCol: {
    // backgroundColor: "green",
    position: "relative",
    width: "100%",
    paddingRight: "15px",
    paddingLeft: "15px",
    flex: "0 0 80%",
    maxWidth: "80%",
    paddingTop: "15px"
  },

  loader: {
    marginTop: '40vh',
  },
  wrapper: {
    display: 'flex',
    width: 'auto',
  },
  twigWrapper: {
    margin: '1rem',
    position: 'relative'
  },
  loadingMoreBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '20px',
  },
  colTabs: {
    '@media (max-width: 520px)': {
      order: "2"
    }
  },
  tabs: {
    display: "flex",
    paddingRight: "15px",
    paddingLeft: "20px"
  },
  oneTab: {
    margin: "5px 15px",
    "&:hover": {
      cursor: 'pointer'
    },
    "&:first-child": {
      marginLeft: '0px'
    }
  },
  oneTabActive: {
    fontWeight: 'bold'
  },
  circleActive: {
    width: '8px',
    height: '8px',
    backgroundColor: '#522583',
    borderRadius: '50%',
    margin: '0px auto'
  },
  nav: {
    backgroundColor: "white"
  },
  subNav: {
    display: "inherit",
    // boxShadow: "1px 1px 10px #98989885"
  },
  orders: {
    display: "flex",
    justifyContent: "space-between",
    paddingRight: "15px"
  },
  searchFor: {
    paddingLeft: "20px"
  },
  orderDiv: {
    display: "flex"
  },
  productCount: {
    marginTop: "5px",
    marginRight: "15px",
    color: "#848484 !important",
  },
  offerTab: {
    display: "flex",
    width: "70%",
    padding: "0px 10px"
  },
  tagText: {
    padding: "10px 5px",
    width: "fit-content",
  },
  tagIcon: {
    marginInlineStart: "4px",
    marginBottom: "2px",
    cursor: 'pointer',
  },
  offerTabText: {
    padding: "10px 5px",
  },
  // spreter: {
  //   width: "1px",
  //   margin: "13px 0px",
  //   boxShadow: "1px 0px 1px #8080804f, 0px 1px 1px #8080804f, -1px 0px 1px #8080804f, 0px -1px 1px #8080804f",
  //   backgroundColor: "#5d5d5d"
  // },
  categoriesTab: {
    padding: "0px 10px",
  },
  "categoriesTabIcon": {
    marginInlineStart: "10px"
  },
  categoriesTabText: {
    padding: "10px 0px",
    width: "fit-content",
    "&:hover": {
      cursor: 'pointer'
    },
    "&:hover + $allCategories": {
      display: "block"
    }
  },
  allCategories: {
    cursor: "default",
    position: "absolute",
    display: "none",
    left: "0px",
    top: "44px",
    width: "100%",
    backgroundColor: "white",
    maxHeight: "250px",
    zIndex: "1",
    padding: "10px 25px",
    "&:hover": {
      display: "block"
    }
  },
  filterDev: {
    // paddingTop: "38px",
    backgroundColor: "white",
    marginTop: "10px",
    padding: "10px 0px"
  },
  filterHeader: {
    // backgroundColor: "red",
    position: "absolute",
    top: "-45px"
  },
  divFilterIcon: {
    width: "28px",
    padding: "6px",
    height: "28px",
    borderRadius: "50%",
    border: "2px solid #cccccc",
    display: "none"
  },
  filterIcon: {
    width: "12px",
    backgroundImage: 'url("images/icon-filter.png")',
    height: "12px",
    backgroundSize: "cover",
    backgroundPosition: "center"
  },
  viewFilter: {
    display: "block !important",
    margin: "0px"
  },
  viewMobileFilterHeader: {
    display: "block !important",
  },
  closeFilter: {
    color: "black",
    position: "absolute",
    top: "25px",
    fontSize: "20px",
    right: "30px"
  },
  mobileFilterHeader: {
    paddingTop: "15px",
    display: "none"
  },
  property: {
    position: "relative",
    marginBottom: "20px",
    marginInlineStart: "10px"
  },
  inputProperty: {
    display: "none"
  },
  titleProperty: {
    paddingLeft: "20px",
    fontSize: "14px"
  },
  textProperty: {
    fontSize: "14px"
    // borderBottom: "2px solid black"
  },
  titleCountProperty: {
    color: "#ababab !important",
    marginInlineStart: "5px"
  },
  listTags: {
    display: "flex",
    margin: "0px",
    flexWrap: "wrap",
    paddingRight: "15px",
    paddingLeft: "20px"
  },
  tag: {
    color: "white",
    padding: "6px 12px",
    fontSize: "12px",
    backgroundColor: "#522583",
    borderRadius: "15px",
    fontWeight: 'bold',
    marginRight: "5px",
    marginBottom: "5px",
  },
  select: {
    minWidth: '100px',
  },
  spreaterFilter: {
    width: "140px",
    backgroundColor: "black",
    height: "2px",
    marginBottom: "10px"
  },
  spreaterProperty: {
    width: "40%",
    backgroundColor: "black",
    height: "2px"
  },
  listProperty: {
    maxHeight: "300px",
    overflow: "auto",
    '&::-webkit-scrollbar': {
      width: "6px"
    },
    '&::-webkit-scrollbar-track': {
      background: "#f1f1f1"
    },
    '&::-webkit-scrollbar-thumb': {
      background: "#888"
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: "#555"
    }
  },
  inputSearch: {
    color: "black",
    width: "95%",
    border: "1px solid #bbbbbb",
    margin: "5px 0px",
    padding: "0px 10px",
    fontSize: "15px",
    borderRadius: "5px"
  },
  colorList: {
    display: "flex",
    flexWrap: "wrap"
  },
  oneColor: {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    boxShadow: "0px 0px 4px 2px #00000030",
    margin: "5px",
    "&:hover": {
      cursor: "pointer"
    }
  },
  selectedColor: {
    border: "3px solid #522583"
  },
  doneDev: {
    position: "fixed",
    bottom: "0px",
    display: "none",
    // z-index: 12
    paddingTop: "6px;",
    backgroundColor: "#522583",
    width: "100%",
    left: "inherit",
    textAlign: "center"
  },
  accordion: {
    "& button": {
      backgroundColor: "transparent",
      border: "none",
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      padding: "0",
      "& svg": {
        marginTop: "4px"
      }
    }
  },
  viewFilterCol: {
    display: "block !important"
  },
  '@media screen and (max-width: 760px)': {
    filterDev: {
      display: "none",
      position: "fixed",
      top: "0px",
      left: "0px",
      zIndex: "11",
      backgroundColor: "white",
      width: "100%",
      padding: "0px 30px",
      overflow: "auto",
      height: "calc(100% - 42px)"
    },
    filterHeader: {
      display: "none",
    },
    filterCol: {
      flex: "0 0 calc(100% )",
      maxWidth: "calc(100% )",
      marginLeft: "0px",
      display: "none"
    },

    containtCol: {
      flex: "0 0 calc(100% )",
      maxWidth: "calc(100% )",
    },
    orderDiv: {
      width: "100%",
      justifyContent: "inherit",
      padding: "0px 10px",
      marginBottom: "4px"
    },
    listTags: {
      padding: "0px 10px",
    },
    tabs: {
      padding: "0px 10px",
    },
    searchFor: {
      display: "none"
    },
    doneDev: {
      display: "block"
    },
    divFilterIcon: {
      display: "block"
    },
    oneTabNav: {
      display: "none"
    }

  },
  spreter: {
    width: "1px",
    margin: "7px 3px",
    height: "20px",
    backgroundColor: "#5d5d5d"
  }
});

export default Search;
